<template>
  <div
    :id="['container_' + id]"
    :class="['myContainer', isActive ? 'active' : '', 'container_id_' + id, isSubHeadPage ? 'sub-head-page' : '']"
    @drop.stop="drop2"
    @dragover.prevent
    @contextmenu.prevent="contextmenuHandle($event)"
    :style="getContainerStyle"
    v-if="!hidePageLayout"
  >
    <!--    用于处理背景色+图片的情况-->
    <div v-if="request_prefix === 'bigScreen'" class="container_bg"></div>
    <div
      v-if="isActive && request_prefix !== 'bigScreen' && !isLayoutStage && !isPhoneFullScreen"
      class="handle-btn-groups"
      ref="del"
    >
      <div>
        <span class="handle-icon-box" @mousedown.stop @click.stop="openMyContainerSet(id)"
          ><i class="icon icon-portal-card-view"></i><span class="icon-tips">设置</span></span
        >
      </div>
    </div>
    <page-head
      v-if="useSubHead"
      :id="id"
      :pageLayoutList="pageLayoutList"
      :zoom="zoom"
      :ids="ids"
      :subHeadPageId="subHeadPageId"
      :generalPageLayoutLen="generalPageLayoutLen"
      :pageLayoutBaseComponent="pageLayoutBaseComponent"
      :pageEnableFullScroll="pageEnableFullScroll"
      @activeHead="setPageLayout(null, 0)"></page-head>
    <template  v-for="(layout, index) in pageLayoutList">
      <cx-drawer
        title="我是标题"
        customClass="customDrawer"
        :key="`drawer-${layout.options.source_id}`"
        v-if="layout.options.inDocument === 'drawer'"
        :visible.sync="drawerVisible[`drawer-${layout.options.source_id}`]"
        :direction="layout.options.drawerParams.direction"
        :append-to-body="true"
        :modal-append-to-body="true"
        :with-header="false"
        :customeStyle="getDrawerStyle(layout, index)"
        :modalStyle="getDrawerModalStyle(layout, index)"
        :zoom="zoom"
        @close="closeDrawer(layout)"
        @contextmenu.native.prevent="contextmenuHandle($event)"
      >
        <div
          @dragover="dragoverEv(true)"
          @dragleave.prevent="isDragover = false"
          @mouseenter.stop="setPageLayoutActive(index)"
          @mouseleave.stop="setPageLayoutunActive(index)"
          :style="pageLayoutStyle(layout, index)"
          :class="[
            getPageLayoutStyle(index, layout),
            'pageLayout_id_' + layout.id,
            { pagelayout_full_scroll: layout.options.enableLayoutFullScroll }
          ]"
          :layoutIndex="layout.id"
        >
          <!--右侧按钮 设计要求2.0的改到左侧-->
          <div
            v-if="!isBigScreenPreview()"
            class="page-layout-sets-wrap"
            :class="[
              unfoldFlag && hoverIndex === index ? 'unfold' : 'fold',
              isFoldAnimate ? 'overflow-hid' : '',
              request_prefix === 'bigScreen' ? 'bigScreen' : 'new',
              offsetTop < 80 && offsetBottom < 80 ? 'is_top' : '',
              offsetTop < 81 && offsetBottom > 79 ? 'is_bottom' : ''
            ]"
            style="top: 0; left: 0"
          >
            <div
              class="page-layout-sets page-layout-sets-more new-btn-groups"
              v-if="(unfoldFlag && hoverIndex === index) || isFolding || request_prefix !== 'bigScreen'"
              @click.stop
            >
              <div class="set-groups-wrap">
                <div class="set-groups base-set-groups">
                  <i class="icon icon-portal-icon_drawer"></i>
                  <span>抽屉</span>
                </div>
                <div class="set-groups handle-btn-name" @click.stop="closeDrawer(layout)">
                  <span class="icon icon-portal-preview-close-one1"></span>
                </div>
              </div>
            </div>
          </div>
          <page-layout
            :baseComponent="pageLayoutBaseComponent"
            ref="pageLayout"
            :layout.sync="layout"
            :zoom="zoom"
            :layoutIndex="index"
            :generalPageLayoutLen="generalPageLayoutLen"
            :id="id"
            :isFullScroll="
              (layout.options.positionType === 'relative' || !layout.options.positionType) &&
              (layout.options.enableLayoutFullScroll || pageEnableFullScroll) &&
              ['header', 'footer'].indexOf(layout.options.inDocument) == -1
            "
            @dragoverEv="dragoverEv(true)"
            @setPageLayout="setPageLayout(layout, index)"
            @delPageLayout="delPageLayout"
            @dropCompleted="isDragover=false"
          />
        </div>
      </cx-drawer>
      <cx-popover
        :key="`popover-${layout.options.source_id}`"
        v-else-if="layout.options.inDocument === 'popover'"
        :visible.sync="popoverVisible[`popover-${layout.options.source_id}`]"
        :placement="layout.options.popoverParams.popoverPositonType"
        :customeStyle="getPopperStyle(layout)"
        :options="layout.options"
        :zoom="zoom"
        @close="closePopper(layout)"
        @contextmenu.native.prevent="contextmenuHandle($event)"
      >
        <div
          @dragover="dragoverEv(true)"
          @dragleave.prevent="isDragover = false"
          @mouseenter.stop="setPageLayoutActive(index)"
          @mouseleave.stop="setPageLayoutunActive(index)"
          :style="pageLayoutStyle(layout, index)"
          :class="[
            getPageLayoutStyle(index, layout),
            'pageLayout_id_' + layout.id,
            { pagelayout_full_scroll: layout.options.enableLayoutFullScroll }
          ]"
          :layoutIndex="layout.id"
        >
          <page-layout
            :baseComponent="pageLayoutBaseComponent"
            ref="pageLayout"
            :layout.sync="layout"
            :zoom="zoom"
            :layoutIndex="index"
            :generalPageLayoutLen="generalPageLayoutLen"
            :id="id"
            :isFullScroll="
              (layout.options.positionType === 'relative' || !layout.options.positionType) &&
              (layout.options.enableLayoutFullScroll || pageEnableFullScroll) &&
              ['header', 'footer'].indexOf(layout.options.inDocument) == -1
            "
            @dragoverEv="dragoverEv(true)"
            @setPageLayout="setPageLayout(layout, index)"
            @delPageLayout="delPageLayout"
            @dropCompleted="isDragover=false"
          />
        </div>
      </cx-popover>
      <!--   固定侧边栏   -->
      <teleport-comp class="enable-left-nav"
                     :key="layout.id"
                     v-else-if="layout.options.enableLeftNav"
                     v-show="needShow(layout)"
                     :style="getLeftNavStyle(layout)"  to="#vueRulerContent" :isPrependChild="true" @contextmenu.native.prevent="contextmenuHandle($event)">
        <div
          :key="layout.id"
          @contextmenu.prevent="parentContextmenuHandle"
          @dragover="wrapperDragoverEv($event, layout.id)"
          @dragleave.prevent="isDragover = false"
          @mouseenter.stop="setPageLayoutActive(index)"
          @mouseleave.stop="setPageLayoutunActive(index)"
          :style="pageLayoutStyle(layout, index)"
          :class="[
          getPageLayoutStyle(index, layout),
          'pageLayout_id_' + layout.id,
          { pagelayout_full_scroll: layout.options.enableLayoutFullScroll }
        ]"
          :layoutIndex="layout.id"
        >
          <!--右侧按钮 设计要求2.0的改到左侧-->
          <div
            v-if="!isBigScreenPreview()"
            class="page-layout-sets-wrap"
            :class="[
            unfoldFlag && hoverIndex === index ? 'unfold' : 'fold',
            isFoldAnimate ? 'overflow-hid' : '',
            request_prefix === 'bigScreen' ? 'bigScreen' : 'new',
            'is_top'
          ]"
            :style="getSetsStyle(layout, index)"
          >
            <div
              class="page-layout-sets page-layout-sets-more new-btn-groups"
              v-if="((unfoldFlag && hoverIndex === index) || isFolding || request_prefix !== 'bigScreen') && isGeneralPageLayout(layout)"
              @click.stop
            >
              <div class="">
                <div class="set-groups-wrap" v-if="showComponentName">
                  <div class="set-groups base-set-groups" @click.stop="displayAllHandles($event,layout, index)">
                    <i class="icon icon-portal-artboard_1"></i>
                    <span>{{
                        layout.options.inDocument === "header"
                          ? "头部"
                          : layout.options.inDocument === "footer"
                            ? "底部"
                            : layout.options.inDocument === "anchor"
                              ? "锚点"
                              : layout.options.enableBayWindow
                                ? "飘窗"
                                : "通栏"
                      }}</span>
                  </div>
                </div>
                <div class="set-groups-wrap">
                  <cx-tooltip
                    v-if="!isHeaderRef(layout) && pageLayoutId === index"
                    content="背景图"
                    class="set-groups"
                    @click.native.stop="openImgLib(layout, index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-bg-back"></span>
                  </cx-tooltip>
                  <div v-if="!isHeaderRef(layout) && pageLayoutId === index" class="set-groups" @click.stop="openBgColor(layout, index)">
                    <cx-tooltip content="背景色" :placement="index === 0 ? 'bottom' : ''">
                      <span class="icon icon-portal-color-paint bottom-color-wrap"><span class="bottom-color" :style="getBgColor(layout.options.bg)"></span></span>
                      <span
                        class="icon icon-portal-arrows-down"
                        :class="showColorSelector ? 'rotate' : ''"
                        style="color: #919191"
                      ></span>
                    </cx-tooltip>
                    <color-selector
                      v-if="showColorSelector"
                      :background.sync="background"
                      :visible.sync="showColorSelector"
                    />
                  </div>
                  <span
                    class="line"
                    v-if="(showUp(index) || showDown(index) || layout.options.inDocument === 'relativeHeader') && pageLayoutId === index"
                  ></span>
                  <!-- 注意！！ 以下部分按钮隐藏不显示，不能删除 放到了右键下调用 -->
                  <cx-tooltip
                    style="display: none !important"
                    content="设为系统样式"
                    v-if="canUploadStyleToSystem"
                    @click.native.stop="savePageLayoutStyle(layout, index)"
                    class="set-groups upload-pageLayout"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-upload-3"></span>
                  </cx-tooltip>
                  <!--功能有bug，暂时屏蔽-->
                  <cx-tooltip
                    style="display: none !important"
                    content="收藏到我的通栏样式"
                    v-if="isGeneralPageLayout(layout)"
                    @click.native.stop="savePageLayoutStyle(layout, index, true)"
                    class="set-groups collect-pageLayout"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-collection"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    style="display: none !important"
                    content="同步到移动端"
                    v-if="request_prefix === 'stage' && layout.options.inDocument !== 'anchor'"
                    class="set-groups sync-pageLayout"
                    @click.native.stop="syncPageLayout(index, layout, 0)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-refresh1"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    style="display: none !important"
                    content="this."
                    v-if="request_prefix === 'stage' && layout.options.inDocument !== 'anchor'"
                    class="set-groups unboundApp-pageLayout"
                    @click.native.stop="syncPageLayout(index, layout, 1)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-sync-default"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    style="display: none !important"
                    content="新增到移动端"
                    :placement="index === 0 ? 'bottom' : ''"
                    v-if="
                    request_prefix === 'stage'
                  "
                    class="set-groups add-click"
                    @click.native.stop="addToAppPageLayout(index, layout.id, layout)"
                  >
                    <span class="icon icon-portal-add-to-app"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    content="上移"
                    v-if="showUp(index) && pageLayoutId === index"
                    class="set-groups"
                    @click.native.stop="upPageLayout(layout, index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-move-up"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    content="下移"
                    v-if="showDown(index) && pageLayoutId === index"
                    class="set-groups"
                    @click.native.stop="downPageLayout(layout, index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-move-down"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    style="display: none !important"
                    content="复制"
                    v-if="canDelOrCopy(layout, index)"
                    class="set-groups copy-click"
                    @click.native.stop="copyPageLayout(layout, index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-copy-small1"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    content="清空"
                    v-if="layout.options.inDocument === 'relativeHeader' && pageLayoutId === index"
                    class="set-groups cleanPageLayout"
                    @click.native.stop="cleanPageLayout(index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-clear"></span>
                  </cx-tooltip>
                  <span v-if="!isHeaderRef(layout) && pageLayoutId === index" class="line"></span>
                  <div
                    class="set-groups handle-btn-name"
                    v-if="!layout.options.enableBayWindow"
                    @click.stop="setClick(layout, index)"
                  >
                    <span class="icon icon-portal-setting1"></span>
                  </div>
                  <cx-tooltip
                    content="删除"
                    v-if="generalPageLayoutLen > 1 && canDelOrCopy(layout, index)"
                    class="set-groups delPageLayout del-click"
                    @click.native.stop="delPageLayout(index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-delete1"></span>
                  </cx-tooltip>
                </div>
              </div>
              <handle-btn-groups
                class="upper-handle-items mt2"
                :ids="ids"
                :isCanDel="false"
                :handleList="handleList"
                :isAllHandleBtns="false"
              />
            </div>
          </div>
          <page-layout
            :baseComponent="pageLayoutBaseComponent"
            ref="pageLayout"
            :layout.sync="layout"
            :zoom="zoom"
            :layoutIndex="index"
            :generalPageLayoutLen="generalPageLayoutLen"
            :id="id"
            :isFullScroll="
            (layout.options.positionType === 'relative' || !layout.options.positionType) &&
            (layout.options.enableLayoutFullScroll || pageEnableFullScroll) &&
            ['header', 'footer'].indexOf(layout.options.inDocument) == -1
          "
            @dragoverEv="dragoverEv"
            @setPageLayout="setPageLayout(layout, index)"
            @delPageLayout="delPageLayout"
            @addNewPageLayout="addNewPageLayout"
            @dropCompleted="isDragover=false"
          />
        </div>
      </teleport-comp>
       <!--   锚点-->
      <teleport-comp  :key="layout.id" v-else-if="layout.options.inDocument === 'anchor' && needShow(layout) " @contextmenu.native.prevent="contextmenuHandle($event)" to="#vueRulerContent">
        <div
            :key="layout.id"
            @dragover="wrapperDragoverEv($event, layout.id)"
            @dragleave.prevent="isDragover = false"
            @mouseenter.stop="setPageLayoutActive(index)"
            @mouseleave.stop="setPageLayoutunActive(index)"
            :style="pageLayoutStyle(layout, index)"
            :class="[
          getPageLayoutStyle(index, layout),
          'pageLayout_id_' + layout.id,
          { pagelayout_full_scroll: layout.options.enableLayoutFullScroll }
        ]"
            :layoutIndex="layout.id"
        >
          <el-button
              v-if="
            !isBigScreenPreview() &&
            request_prefix !== 'bigScreen' &&
            index > 0 &&
            index <= pageLayoutList.length - 1 &&
            !layout.options.enableBayWindow &&
            layout.options.inDocument !== 'anchor' &&
            layout.options.inDocument !== 'relativeHeader' &&
            !subPagePreview &&
            !isOnlyHead
          "
              class="container_btn container_btn_top"
              @click.stop="addPageLayout(index - 1)"
              circle
              icon="icon-portal-add_bold"
          />
          <!--右侧按钮 设计要求2.0的改到左侧-->
          <div
              v-if="!isBigScreenPreview()"
              class="page-layout-sets-wrap"
              :class="[
            unfoldFlag && hoverIndex === index ? 'unfold' : 'fold',
            isFoldAnimate ? 'overflow-hid' : '',
            request_prefix === 'bigScreen' ? 'bigScreen' : 'new',
            'is_top'
          ]"
              :style="getSetsStyle(layout, index)"
          >
            <div
                class="page-layout-sets page-layout-sets-more new-btn-groups"
                v-if="((unfoldFlag && hoverIndex === index) || isFolding || request_prefix !== 'bigScreen') && isGeneralPageLayout(layout)"
                @click.stop
            >
              <div class="">
                <div class="set-groups-wrap" v-if="showComponentName">
                  <div class="set-groups base-set-groups" @click.stop="displayAllHandles($event,layout, index)">
                    <i class="icon icon-portal-artboard_1"></i>
                    <span>{{
                        layout.options.inDocument === "header"
                            ? "头部"
                            : layout.options.inDocument === "footer"
                                ? "底部"
                                : layout.options.inDocument === "anchor"
                                    ? "锚点"
                                    : layout.options.enableBayWindow
                                        ? "飘窗"
                                        : "通栏"
                      }}</span>
                  </div>
                </div>
                <div class="set-groups-wrap">
                  <cx-tooltip
                      v-if="!isHeaderRef(layout) && pageLayoutId === index"
                      content="背景图"
                      class="set-groups"
                      @click.native.stop="openImgLib(layout, index)"
                      :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-bg-back"></span>
                  </cx-tooltip>
                  <div v-if="!isHeaderRef(layout) && pageLayoutId === index" class="set-groups" @click.stop="openBgColor(layout, index)">
                    <cx-tooltip content="背景色" :placement="index === 0 ? 'bottom' : ''">
                      <span class="icon icon-portal-color-paint bottom-color-wrap"><span class="bottom-color" :style="getBgColor(layout.options.bg)"></span></span>
                      <span
                          class="icon icon-portal-arrows-down"
                          :class="showColorSelector ? 'rotate' : ''"
                          style="color: #919191"
                      ></span>
                    </cx-tooltip>
                    <color-selector
                        v-if="showColorSelector"
                        :background.sync="background"
                        :visible.sync="showColorSelector"
                    />
                  </div>
                  <span
                      class="line"
                      v-if="(showUp(index) || showDown(index) || layout.options.inDocument === 'relativeHeader') && pageLayoutId === index"
                  ></span>
                  <!-- 注意！！ 以下部分按钮隐藏不显示，不能删除 放到了右键下调用 -->
                  <cx-tooltip
                      style="display: none !important"
                      content="设为系统样式"
                      v-if="canUploadStyleToSystem"
                      @click.native.stop="savePageLayoutStyle(layout, index)"
                      class="set-groups upload-pageLayout"
                      :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-upload-3"></span>
                  </cx-tooltip>
                  <!--功能有bug，暂时屏蔽-->
                  <cx-tooltip
                      style="display: none !important"
                      content="收藏到我的通栏样式"
                      v-if="isGeneralPageLayout(layout)"
                      @click.native.stop="savePageLayoutStyle(layout, index, true)"
                      class="set-groups collect-pageLayout"
                      :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-collection"></span>
                  </cx-tooltip>
                  <cx-tooltip
                      style="display: none !important"
                      content="同步到移动端"
                      v-if="request_prefix === 'stage' && layout.options.inDocument !== 'anchor'"
                      class="set-groups sync-pageLayout"
                      @click.native.stop="syncPageLayout(index, layout, 0)"
                      :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-refresh1"></span>
                  </cx-tooltip>
                  <cx-tooltip
                      style="display: none !important"
                      content="同步原始样式"
                      v-if="request_prefix === 'stage' && layout.options.inDocument !== 'anchor'"
                      class="set-groups unboundApp-pageLayout"
                      @click.native.stop="syncPageLayout(index, layout, 1)"
                      :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-sync-default"></span>
                  </cx-tooltip>
                  <cx-tooltip
                      style="display: none !important"
                      content="新增到移动端"
                      :placement="index === 0 ? 'bottom' : ''"
                      v-if="
                    request_prefix === 'stage'
                  "
                      class="set-groups add-click"
                      @click.native.stop="addToAppPageLayout(index, layout.id, layout)"
                  >
                    <span class="icon icon-portal-add-to-app"></span>
                  </cx-tooltip>
                  <cx-tooltip
                      content="上移"
                      v-if="showUp(index) && pageLayoutId === index"
                      class="set-groups"
                      @click.native.stop="upPageLayout(layout, index)"
                      :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-move-up"></span>
                  </cx-tooltip>
                  <cx-tooltip
                      content="下移"
                      v-if="showDown(index) && pageLayoutId === index"
                      class="set-groups"
                      @click.native.stop="downPageLayout(layout, index)"
                      :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-move-down"></span>
                  </cx-tooltip>
                  <cx-tooltip
                      style="display: none !important"
                      content="复制"
                      v-if="canDelOrCopy(layout, index)"
                      class="set-groups copy-click"
                      @click.native.stop="copyPageLayout(layout, index)"
                      :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-copy-small1"></span>
                  </cx-tooltip>
                  <cx-tooltip
                      content="清空"
                      v-if="layout.options.inDocument === 'relativeHeader' && pageLayoutId === index"
                      class="set-groups cleanPageLayout"
                      @click.native.stop="cleanPageLayout(index)"
                      :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-clear"></span>
                  </cx-tooltip>
                  <span v-if="!isHeaderRef(layout) && pageLayoutId === index" class="line"></span>
                  <div
                      class="set-groups handle-btn-name"
                      v-if="!layout.options.enableBayWindow"
                      @click.stop="setClick(layout, index)"
                  >
                    <span class="icon icon-portal-setting1"></span>
                  </div>
                  <cx-tooltip
                      content="删除"
                      v-if="generalPageLayoutLen > 1 && canDelOrCopy(layout, index)"
                      class="set-groups delPageLayout del-click"
                      @click.native.stop="delPageLayout(index)"
                      :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-delete1"></span>
                  </cx-tooltip>
                </div>
              </div>
              <handle-btn-groups
                  class="upper-handle-items mt2"
                  :ids="ids"
                  :isCanDel="false"
                  :handleList="handleList"
                  :isAllHandleBtns="false"
              />
            </div>
          </div>
          <el-button
              v-if="
            ((!isBigScreenPreview() && request_prefix !== 'bigScreen' && index < pageLayoutList.length - 1) ||
              (index === pageLayoutList.length - 1 && pageLayoutList[index].options.inDocument !== 'footer')) &&
            !layout.options.enableBayWindow &&
            layout.options.inDocument !== 'anchor' &&
            !subPagePreview &&
            !isOnlyHead"
              class="container_btn"
              @click.stop="addPageLayout(index)"
              circle
              icon="icon-portal-add_bold"
          />
          <page-layout
              :baseComponent="pageLayoutBaseComponent"
              ref="pageLayout"
              :layout.sync="layout"
              :zoom="zoom"
              :layoutIndex="index"
              :generalPageLayoutLen="generalPageLayoutLen"
              :id="id"
              :isFullScroll="
            (layout.options.positionType === 'relative' || !layout.options.positionType) &&
            (layout.options.enableLayoutFullScroll || pageEnableFullScroll) &&
            ['header', 'footer'].indexOf(layout.options.inDocument) == -1
          "
              @dragoverEv="dragoverEv"
              @setPageLayout="setPageLayout(layout, index)"
              @delPageLayout="delPageLayout"
              @addNewPageLayout="addNewPageLayout"
              @dropCompleted="isDragover=false"
          />
          <div v-if="layout.options.enableBayWindow && layout.options.bayManualClose" class="closed-btn">
            <i class="el-icon-close"></i>
          </div>
          <!-- <div @mouseenter.stop class="edit-shape" v-if="showEditShape" @click.stop="hideEditShape"></div> -->
        </div>
      </teleport-comp>
      <!--  固定定位通栏 -->
      <teleport-comp
        :key="layout.id"
        v-show="needShow(layout)"
        v-else-if="layout.options.positionType === 'fixed' || layout.options.enableBayWindow"
        to="#vueRulerContent" @contextmenu.native.prevent="contextmenuHandle($event)">
        <div
          :key="layout.id"
          @contextmenu.prevent="parentContextmenuHandle"
          @dragover="wrapperDragoverEv($event, layout.id)"
          @dragleave.prevent="isDragover = false"
          @mouseenter.stop="setPageLayoutActive(index)"
          @mouseleave.stop="setPageLayoutunActive(index)"
          :style="pageLayoutStyle(layout, index)"
          :class="[
          getPageLayoutStyle(index, layout),
          'pageLayout_id_' + layout.id,
          { pagelayout_full_scroll: layout.options.enableLayoutFullScroll }
        ]"
          :layoutIndex="layout.id"
        >
          <!--右侧按钮 设计要求2.0的改到左侧-->
          <div
            v-if="!isBigScreenPreview()"
            class="page-layout-sets-wrap"
            :class="[
            unfoldFlag && hoverIndex === index ? 'unfold' : 'fold',
            isFoldAnimate ? 'overflow-hid' : '',
            request_prefix === 'bigScreen' ? 'bigScreen' : 'new',
            'is_top'
          ]"
            :style="getSetsStyle(layout, index)"
          >
            <div
              class="page-layout-sets page-layout-sets-more new-btn-groups"
              v-if="((unfoldFlag && hoverIndex === index) || isFolding || request_prefix !== 'bigScreen') && isGeneralPageLayout(layout)"
              @click.stop
            >
              <div class="">
                <div class="set-groups-wrap" v-if="showComponentName">
                  <div class="set-groups base-set-groups" @click.stop="displayAllHandles($event,layout, index)">
                    <i class="icon icon-portal-artboard_1"></i>
                    <span>{{
                        layout.options.inDocument === "header"
                          ? "头部"
                          : layout.options.inDocument === "footer"
                            ? "底部"
                            : layout.options.inDocument === "anchor"
                              ? "锚点"
                              : layout.options.enableBayWindow
                                ? "飘窗"
                                : "通栏"
                      }}</span>
                  </div>
                </div>
                <div class="set-groups-wrap">
                  <cx-tooltip
                    v-if="!isHeaderRef(layout) && pageLayoutId === index"
                    content="背景图"
                    class="set-groups"
                    @click.native.stop="openImgLib(layout, index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-bg-back"></span>
                  </cx-tooltip>
                  <div v-if="!isHeaderRef(layout) && pageLayoutId === index" class="set-groups" @click.stop="openBgColor(layout, index)">
                    <cx-tooltip content="背景色" :placement="index === 0 ? 'bottom' : ''">
                      <span class="icon icon-portal-color-paint bottom-color-wrap"><span class="bottom-color" :style="getBgColor(layout.options.bg)"></span></span>
                      <span
                        class="icon icon-portal-arrows-down"
                        :class="showColorSelector ? 'rotate' : ''"
                        style="color: #919191"
                      ></span>
                    </cx-tooltip>
                    <color-selector
                      v-if="showColorSelector"
                      :background.sync="background"
                      :visible.sync="showColorSelector"
                    />
                  </div>
                  <span
                    class="line"
                    v-if="(showUp(index) || showDown(index) || layout.options.inDocument === 'relativeHeader') && pageLayoutId === index"
                  ></span>
                  <!-- 注意！！ 以下部分按钮隐藏不显示，不能删除 放到了右键下调用 -->
                  <cx-tooltip
                    style="display: none !important"
                    content="设为系统样式"
                    v-if="canUploadStyleToSystem"
                    @click.native.stop="savePageLayoutStyle(layout, index)"
                    class="set-groups upload-pageLayout"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-upload-3"></span>
                  </cx-tooltip>
                  <!--功能有bug，暂时屏蔽-->
                  <cx-tooltip
                    style="display: none !important"
                    content="收藏到我的通栏样式"
                    v-if="isGeneralPageLayout(layout)"
                    @click.native.stop="savePageLayoutStyle(layout, index, true)"
                    class="set-groups collect-pageLayout"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-collection"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    style="display: none !important"
                    content="同步到移动端"
                    v-if="request_prefix === 'stage' && layout.options.inDocument !== 'anchor'"
                    class="set-groups sync-pageLayout"
                    @click.native.stop="syncPageLayout(index, layout, 0)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-refresh1"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    style="display: none !important"
                    content="同步原始样式"
                    v-if="request_prefix === 'stage' && layout.options.inDocument !== 'anchor'"
                    class="set-groups unboundApp-pageLayout"
                    @click.native.stop="syncPageLayout(index, layout, 1)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-sync-default"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    style="display: none !important"
                    content="新增到移动端"
                    :placement="index === 0 ? 'bottom' : ''"
                    v-if="
                    request_prefix === 'stage'
                  "
                    class="set-groups add-click"
                    @click.native.stop="addToAppPageLayout(index, layout.id, layout)"
                  >
                    <span class="icon icon-portal-add-to-app"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    content="上移"
                    v-if="showUp(index) && pageLayoutId === index"
                    class="set-groups"
                    @click.native.stop="upPageLayout(layout, index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-move-up"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    content="下移"
                    v-if="showDown(index) && pageLayoutId === index"
                    class="set-groups"
                    @click.native.stop="downPageLayout(layout, index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-move-down"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    style="display: none !important"
                    content="复制"
                    v-if="canDelOrCopy(layout, index)"
                    class="set-groups copy-click"
                    @click.native.stop="copyPageLayout(layout, index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-copy-small1"></span>
                  </cx-tooltip>
                  <cx-tooltip
                    content="清空"
                    v-if="layout.options.inDocument === 'relativeHeader' && pageLayoutId === index"
                    class="set-groups cleanPageLayout"
                    @click.native.stop="cleanPageLayout(index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-clear"></span>
                  </cx-tooltip>
                  <span v-if="!isHeaderRef(layout) && pageLayoutId === index" class="line"></span>
                  <div
                    class="set-groups handle-btn-name"
                    v-if="!layout.options.enableBayWindow"
                    @click.stop="setClick(layout, index)"
                  >
                    <span class="icon icon-portal-setting1"></span>
                  </div>
                  <cx-tooltip
                    content="删除"
                    v-if="generalPageLayoutLen > 1 && canDelOrCopy(layout, index)"
                    class="set-groups delPageLayout del-click"
                    @click.native.stop="delPageLayout(index)"
                    :placement="index === 0 ? 'bottom' : ''"
                  >
                    <span class="icon icon-portal-delete1"></span>
                  </cx-tooltip>
                </div>
              </div>
              <handle-btn-groups
                class="upper-handle-items mt2"
                :ids="ids"
                :isCanDel="false"
                :handleList="handleList"
                :isAllHandleBtns="false"
              />
            </div>
          </div>
          <page-layout
            :baseComponent="pageLayoutBaseComponent"
            ref="pageLayout"
            :layout.sync="layout"
            :zoom="zoom"
            :layoutIndex="index"
            :generalPageLayoutLen="generalPageLayoutLen"
            :id="id"
            :isFullScroll="
            (layout.options.positionType === 'relative' || !layout.options.positionType) &&
            (layout.options.enableLayoutFullScroll || pageEnableFullScroll) &&
            ['header', 'footer'].indexOf(layout.options.inDocument) == -1
          "
            @dragoverEv="dragoverEv"
            @setPageLayout="setPageLayout(layout, index)"
            @delPageLayout="delPageLayout"
            @addNewPageLayout="addNewPageLayout"
            @dropCompleted="isDragover=false"
          />
        </div>
      </teleport-comp>
      <div
        v-else-if="needShow(layout) && checkIfShowHeader(layout)"
        :key="layout.id"
        @contextmenu.prevent="parentContextmenuHandle"
        @dragover="wrapperDragoverEv($event, layout.id)"
        @dragleave.prevent="isDragover = false"
        @mouseenter.stop="setPageLayoutActive(index)"
        @mouseleave.stop="setPageLayoutunActive(index)"
        :style="pageLayoutStyle(layout, index)"
        :class="[
          getPageLayoutStyle(index, layout),
          'pageLayout_id_' + layout.id,
          { pagelayout_full_scroll: layout.options.enableLayoutFullScroll }
        ]"
        :layoutIndex="layout.id"
      >
        <el-button
          v-if="
            !isBigScreenPreview() &&
            request_prefix !== 'bigScreen' &&
            index > 0 &&
            index <= pageLayoutList.length - 1 &&
            !layout.options.enableBayWindow &&
            layout.options.inDocument !== 'anchor' &&
            layout.options.inDocument !== 'relativeHeader' &&
            !subPagePreview &&
            !isOnlyHead
          "
          class="container_btn container_btn_top"
          @click.stop="addPageLayout(index - 1)"
          circle
          icon="icon-portal-add_bold"
        />
        <!--右侧按钮 设计要求2.0的改到左侧-->
        <div
          v-if="!isBigScreenPreview()"
          class="page-layout-sets-wrap"
          :class="[
            unfoldFlag && hoverIndex === index ? 'unfold' : 'fold',
            isFoldAnimate ? 'overflow-hid' : '',
            request_prefix === 'bigScreen' ? 'bigScreen' : 'new',
            'is_top'
          ]"
          :style="getSetsStyle(layout, index)"
        >
          <div
            class="page-layout-sets page-layout-sets-more new-btn-groups"
            v-if="((unfoldFlag && hoverIndex === index) || isFolding || request_prefix !== 'bigScreen') && isGeneralPageLayout(layout)"
            @click.stop
          >
            <div class="">
              <div class="set-groups-wrap" v-if="showComponentName">
                <div class="set-groups base-set-groups" @click.stop="displayAllHandles($event,layout, index)">
                  <i class="icon icon-portal-artboard_1"></i>
                  <span>{{
                    layout.options.inDocument === "header"
                      ? "头部"
                      : layout.options.inDocument === "footer"
                      ? "底部"
                      : layout.options.inDocument === "anchor"
                      ? "锚点"
                      : layout.options.enableBayWindow
                      ? "飘窗"
                      : "通栏"
                  }}</span>
                </div>
              </div>
              <div class="set-groups-wrap">
                <cx-tooltip
                  v-if="!isHeaderRef(layout) && pageLayoutId === index"
                  content="背景图"
                  class="set-groups"
                  @click.native.stop="openImgLib(layout, index)"
                  :placement="index === 0 ? 'bottom' : ''"
                >
                  <span class="icon icon-portal-bg-back"></span>
                </cx-tooltip>
                <div v-if="!isHeaderRef(layout) && pageLayoutId === index" class="set-groups" @click.stop="openBgColor(layout, index)">
                  <cx-tooltip content="背景色" :placement="index === 0 ? 'bottom' : ''">
                    <span class="icon icon-portal-color-paint bottom-color-wrap"><span class="bottom-color" :style="getBgColor(layout.options.bg)"></span></span>
                    <span
                      class="icon icon-portal-arrows-down"
                      :class="showColorSelector ? 'rotate' : ''"
                      style="color: #919191"
                    ></span>
                  </cx-tooltip>
                  <color-selector
                    v-if="showColorSelector"
                    :background.sync="background"
                    :visible.sync="showColorSelector"
                  />
                </div>
                <span
                  class="line"
                  v-if="(showUp(index) || showDown(index) || layout.options.inDocument === 'relativeHeader') && pageLayoutId === index"
                ></span>
                <!-- 注意！！ 以下部分按钮隐藏不显示，不能删除 放到了右键下调用 -->
                <cx-tooltip
                  style="display: none !important"
                  content="设为系统样式"
                  v-if="canUploadStyleToSystem"
                  @click.native.stop="savePageLayoutStyle(layout, index)"
                  class="set-groups upload-pageLayout"
                  :placement="index === 0 ? 'bottom' : ''"
                >
                  <span class="icon icon-portal-upload-3"></span>
                </cx-tooltip>
                <!--功能有bug，暂时屏蔽-->
                <cx-tooltip
                  style="display: none !important"
                  content="收藏到我的通栏样式"
                  v-if="isGeneralPageLayout(layout)"
                  @click.native.stop="savePageLayoutStyle(layout, index, true)"
                  class="set-groups collect-pageLayout"
                  :placement="index === 0 ? 'bottom' : ''"
                >
                  <span class="icon icon-portal-collection"></span>
                </cx-tooltip>
                <cx-tooltip
                  style="display: none !important"
                  content="同步到移动端"
                  v-if="request_prefix === 'stage' && layout.options.inDocument !== 'anchor'"
                  class="set-groups sync-pageLayout"
                  @click.native.stop="syncPageLayout(index, layout, 0)"
                  :placement="index === 0 ? 'bottom' : ''"
                >
                  <span class="icon icon-portal-refresh1"></span>
                </cx-tooltip>
                <cx-tooltip
                  style="display: none !important"
                  content="同步原始样式"
                  v-if="request_prefix === 'stage' && layout.options.inDocument !== 'anchor'"
                  class="set-groups unboundApp-pageLayout"
                  @click.native.stop="syncPageLayout(index, layout, 1)"
                  :placement="index === 0 ? 'bottom' : ''"
                >
                  <span class="icon icon-portal-sync-default"></span>
                </cx-tooltip>
                <cx-tooltip
                  style="display: none !important"
                  content="新增到移动端"
                  :placement="index === 0 ? 'bottom' : ''"
                  v-if="
                    request_prefix === 'stage'
                  "
                  class="set-groups add-click"
                  @click.native.stop="addToAppPageLayout(index, layout.id, layout)"
                >
                  <span class="icon icon-portal-add-to-app"></span>
                </cx-tooltip>
                <cx-tooltip
                  content="上移"
                  v-if="showUp(index) && pageLayoutId === index"
                  class="set-groups"
                  @click.native.stop="upPageLayout(layout, index)"
                  :placement="index === 0 ? 'bottom' : ''"
                >
                  <span class="icon icon-portal-move-up"></span>
                </cx-tooltip>
                <cx-tooltip
                  content="下移"
                  v-if="showDown(index) && pageLayoutId === index"
                  class="set-groups"
                  @click.native.stop="downPageLayout(layout, index)"
                  :placement="index === 0 ? 'bottom' : ''"
                >
                  <span class="icon icon-portal-move-down"></span>
                </cx-tooltip>
                <cx-tooltip
                  style="display: none !important"
                  content="复制"
                  v-if="canDelOrCopy(layout, index)"
                  class="set-groups copy-click"
                  @click.native.stop="copyPageLayout(layout, index)"
                  :placement="index === 0 ? 'bottom' : ''"
                >
                  <span class="icon icon-portal-copy-small1"></span>
                </cx-tooltip>
                <cx-tooltip
                  content="清空"
                  v-if="layout.options.inDocument === 'relativeHeader' && pageLayoutId === index"
                  class="set-groups cleanPageLayout"
                  @click.native.stop="cleanPageLayout(index)"
                  :placement="index === 0 ? 'bottom' : ''"
                >
                  <span class="icon icon-portal-clear"></span>
                </cx-tooltip>
                <span v-if="!isHeaderRef(layout) && pageLayoutId === index" class="line"></span>
                <div
                  class="set-groups handle-btn-name"
                  v-if="!layout.options.enableBayWindow"
                  @click.stop="setClick(layout, index)"
                >
                  <span class="icon icon-portal-setting1"></span>
                </div>
                <cx-tooltip
                  content="删除"
                  v-if="generalPageLayoutLen > 1 && canDelOrCopy(layout, index)"
                  class="set-groups delPageLayout del-click"
                  @click.native.stop="delPageLayout(index)"
                  :placement="index === 0 ? 'bottom' : ''"
                >
                  <span class="icon icon-portal-delete1"></span>
                </cx-tooltip>
              </div>
            </div>
            <handle-btn-groups
              class="upper-handle-items mt2"
              :ids="ids"
              :isCanDel="false"
              :handleList="handleList"
              :isAllHandleBtns="false"
            />
          </div>
        </div>
        <el-button
          v-if="
            ((!isBigScreenPreview() && request_prefix !== 'bigScreen' && index < pageLayoutList.length - 1) ||
              (index === pageLayoutList.length - 1 && pageLayoutList[index].options.inDocument !== 'footer')) &&
            !layout.options.enableBayWindow &&
            layout.options.inDocument !== 'anchor' &&
            !subPagePreview &&
            !isOnlyHead
          "
          class="container_btn"
          @click.stop="addPageLayout(index)"
          circle
          icon="icon-portal-add_bold"
        />
        <page-layout
          :baseComponent="pageLayoutBaseComponent"
          ref="pageLayout"
          :layout.sync="layout"
          :zoom="zoom"
          :layoutIndex="index"
          :generalPageLayoutLen="generalPageLayoutLen"
          :id="id"
          :isFullScroll="
            (layout.options.positionType === 'relative' || !layout.options.positionType) &&
            (layout.options.enableLayoutFullScroll || pageEnableFullScroll) &&
            ['header', 'footer'].indexOf(layout.options.inDocument) == -1
          "
          @dragoverEv="dragoverEv"
          @setPageLayout="setPageLayout(layout, index)"
          @delPageLayout="delPageLayout"
          @addNewPageLayout="addNewPageLayout"
          @dropCompleted="isDragover=false"
        />
        <div v-if="layout.options.enableBayWindow && layout.options.bayManualClose" class="closed-btn">
          <i class="el-icon-close"></i>
        </div>
        <!-- <div @mouseenter.stop class="edit-shape" v-if="showEditShape" @click.stop="hideEditShape"></div> -->
      </div>
    </template>

    <pageLayout-style
      v-if="showPageLayoutStyle"
      :curPageLayoutIndex="curPageLayoutIndex"
      :pageLayoutList="pageLayoutList"
      :id="id"
      :showDialog.sync="showPageLayoutStyle"
    >
    </pageLayout-style>
    <!-- 单元格 克隆状态下的遮罩 -->
    <div @click.stop v-if="isClonePattern" id="cloneShade"></div>
    <!-- 单元格 克隆状态下的遮罩 end-->
    <!-- 复杂组件聚焦状态下的遮罩 -->
    <!-- <div class="edit-shape" v-if="showEditShape" @click.stop="hideEditShape"></div> -->
    <!-- 普通组件打开右侧栏时的遮罩 -->
    <!-- <div class="edit-shape" v-if="showShape" @click.stop="hideEditShape"></div> -->
    <div v-if="subPagePreview" class="substage_shade" @click="subPageShadeClick"></div>
  </div>
</template>

<script>
import teleportComp from "./teleportComp.js"
import pageLayout from "materials/pageLayout/render/index"
import handleBtnGroups from "./publicComponent/handleBtnGroups"
import { isExist } from "../utils/index"
import { handleChildAppid } from "@/utils/reCreatAppid"
import { getFirstModuleEncId, getSyetemModuleJson } from "@/utils/initEv.js"
import componentMixIn from "./stageComponentMixin.js"
import {
  primaryBigScreenGenerator as primarybigScreenGenerator,
  primaryBigScreenPageLayoutGenerator as primarybigScreenPageLayoutGenerator
} from "../store/modules/bigScreen/state"
import {
  primaryStageGenerator as primarystageGenerator,
  primaryStagePageLayoutGenerator as primarystagePageLayoutGenerator
} from "../store/modules/stage/state"
import {
  primaryAppStageGenerator as primaryappStageGenerator,
  primaryappStagePageLayoutGenerator as primaryappStagePageLayoutGenerator
} from "../store/modules/appStage/state"

import draggable from "vuedraggable"
import pageLayoutStyle from "./toolbar-option-components/styles/pageLayout-style"
import { deepChangeUid, decrypt, smartMathMax } from "utils"
import cxTabsState from "../store/modules/menu/menuComponent/cxTabsState"
import $ from "jquery"
import pagelayoutDrawerControllerMixin from "./pagelayoutDrawerControllerMixin"
import {delAnimateGroup, editAnimateAddLayout} from "../utils/event/animate"
import { CATEGORY_MODE } from "@/consts/index.js"
import pageHead from './page-head.vue'
const mockData = {
  primarybigScreenGenerator,
  primaryappStageGenerator,
  primarystageGenerator,
  primarybigScreenPageLayoutGenerator,
  primarystagePageLayoutGenerator,
  primaryappStagePageLayoutGenerator
}

export default {
  name: "page-layout-stage",
  mixins: [componentMixIn, pagelayoutDrawerControllerMixin],
  components: {
    pageLayout,
    draggable,
    pageLayoutStyle,
    handleBtnGroups,
    teleportComp,
    pageHead
  },
  props: {
    index: {
      type: Number
    },
    id: {
      type: Number,
      default: 0
    },
    parentElement: {
      type: Object
    },
    stageType: {
      type: String,
      default: undefined
    },
    isBigScreen: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Number,
      default: 1
    },
    isActive: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 1920
    },
    height: {
      type: Number,
      default: 600
    },
    containerOptions: {
      type: Object
    },
    pageId: {
      type: String
    },
    // scrollLeft: {
    //   type: Number
    // },
    scrollTop: {
      type: Number
    },
    rulerThickness: {
      type: Number
    },
    contentWidth: {
      type: Number
    },
    appEditWidth: {
      type: Number
    }
  },
  data() {
    return {
      isDragover: false,
      dragoverIndex: null,
      this2: this,
      saveModuleForm: {
        name: null,
        type: null
      },
      formLabelWidth: "120px",
      dialogSystemLayout: false,
      cacheDataTypes: [],
      restDataUrl: null,
      typeVal: null,
      initContainerH: null,
      containerBtnLock: null,
      colsIdFromActiveRect: [],
      showModuleHandles: true,
      mounted: false,
      autoPlayAnimate: true,
      activeIndex: undefined,
      hoverIndex: undefined,
      unfoldFlag: false,
      isFolding: false,
      isFoldAnimate: false, // 是否正在 展开，折叠动画中
      handleList: [
        {
          name: "页面",
          iconClass: "icon-portal-page-layer",
          shape: "page",
          ids: {}
        }
      ],
      newRectIds: [],
      newRectLen: 0, //新增通栏中组件的个数
      hasAddedLen: 0,
      baseComponent: [
        "cxText",
        "cxLabel",
        "imageComponent",
        "cxHomeLine",
        "cxButton",
        "cxEditor",
        "cxShape",
        "cxRadio",
        "cxVideo",
        "cxAudio",
        "cxDigitRoll",
        "cxIcon",
        "cxVerticalLine",
        "cxNoteEditor",
        "cxBreadCrumbs",
        "cxCalendar",
        "cxTabs",
        "cxSelect",
        "cxWeather",
        "cxDate",
        "cxReturn",
        "cxBorder",
        "cxAnimate",
        "cxIframe",
        "cxCode",
        "cxAutoLayout",
        "cxDatePicker",
        "cxInput",
        "cxAnchorComponent",
        "cxIP",
        "cxSort",
        "cxShare"
      ],
      // 瀑布流新增iframe
      waterFlowBaseComponent:  [
        "cxText",
        "cxLabel",
        "imageComponent",
        "cxHomeLine",
        "cxButton",
        "cxEditor",
        "cxShape",
        "cxRadio",
        "cxVideo",
        "cxAudio",
        "cxDigitRoll",
        "cxIcon",
        "cxVerticalLine",
        "cxNoteEditor",
        "cxBreadCrumbs",
        "cxTabs",
        "cxSelect",
        "cxWeather",
        "cxDate",
        "cxReturn",
        "cxBorder",
        "cxAnimate",
        "cxCode",
        "cxAutoLayout",
        "cxDatePicker",
        "cxInput",
        "cxAnchorComponent",
        "cxIP",
        "cxSort",
        "cxShare"
      ],
      showPageLayoutStyle: false,
      curPageLayoutIndex: undefined,
      offsetTop: 0,
      offsetBottom: 80,
      isShowAllBtns: false,
      showColorSelector: false,
      idChange: false,
      currentDragoverId: '',
      hidePageLayout:false
    }
  },
  computed: {
    isSubHeadPage() {
      return this.$store.state[this.request_prefix].page.isSubHeadPage
    },
    checkIfShowHeader() {
      return function (layout) {
        if (layout.options.inDocument !== 'header') return true
        return !this.useSubHead
      }
    },
    useSubHead() {
      // 是否引用当前页面的网站级别的二级头
      return this.$store.state[this.request_prefix].page.useSubHead
    },
    subHeadPageId() {
      return this.$store.state[this.request_prefix].page.subHeadPageId
    },
    pageLayoutBaseComponent() {
      return this.isUseNewPageLayout ? this.waterFlowBaseComponent: this.baseComponent
    },
    subPagePreview() {
      return !!this.$store.state.states.getDataPageIds.pv
    },
    isOnlyHead() {
      return this.$store.state[this.request_prefix].page.isSubHeadPage
    },
    getSetsStyle() {
      return function(layout, index) {
        // 通栏工具栏的位置
        if (
          layout.options.inDocument === "anchor" ||
          layout.options.enableBayWindow ||
          (this.ids.pageLayoutId != index && this.activeIndex != index)
        ) {
          return
        }
        let scrollLeft = this.$store.state.states.scrollLeft
        let left = this.showAllScreen ? scrollLeft + 220 + "px" : scrollLeft + "px"
        // let bottom
        // // 鉴于工具栏的高度是固定的，一般情况不得修改，所以没有不要动态获取
        // const handleHeight = 38
        // if(this.offsetTop < handleHeight  && this.offsetTop >0 ){
        //     bottom=`calc(100% - ${handleHeight - this.offsetTop}px)`
        // }else if(this.offsetTop < 0){
        //     bottom= `calc(100% - ${handleHeight}px)`
        // }else{
        //     bottom= '100%'
        // }
        return {
          left: left
          // left: left,
          // bottom: bottom
        }
      }
    },
    generalPageLayoutLen() {
      //计算出来头，底的通栏个数
      let len = 0
      this.pageLayoutList.forEach(pageLayout => {
        let type = pageLayout.options.inDocument
        if (
          type !== "header" &&
          type !== "footer" &&
          type !== "anchor" &&
          pageLayout.options.position !== "fixed" &&
          pageLayout.options.isShow
        ) {
          len++
        }
      })
      console.log("len", len)
      return len
    },
    canUploadStyleToSystem() {
      let userPermissionCode = this.$store.state.states.userPermission
      return Array.isArray(userPermissionCode) && userPermissionCode?.indexOf(11) > -1 ? true : false
    },
    needShow() {
      return function(layout) {
        let isShow = true
        if (layout.options && layout.options.hasOwnProperty("isShow")) {
          isShow = layout.options.isShow
        }
        return isShow
      }
    },
    showUp() {
      // 是否显示上移
      return function(index) {
        if (index === 0) {
          return false
        }
        if (index === 1 && this.pageLayoutList[0].options.inDocument === "header") {
          return false
        }
        if (
          index === this.pageLayoutList.length - 1 &&
          this.pageLayoutList[this.pageLayoutList.length - 1].options.inDocument === "footer"
        ) {
          return false
        }
        if ( this.pageLayoutList[index].options.inDocument === "anchor") {
          return false
        }
        return true
      }
    },
    showDown() {
      // 是否显示下移
      return function(index) {
        if (index === this.pageLayoutList.length - 1) {
          return false
        }
        if (
          index === this.pageLayoutList.length - 2 &&
          this.pageLayoutList[this.pageLayoutList.length - 1].options.inDocument === "footer"
        ) {
          return false
        }
        if (index === 0 && this.pageLayoutList[0].options.inDocument === "header") {
          return false
        }
        if (this.pageLayoutList[index].options.inDocument === "anchor") {
          return false
        }
        return true
      }
    },
    canDelOrCopy() {
      return function(layout, index) {
        if ((index === 0 && layout.options.inDocument === "header") || layout.options.inDocument === "relativeHeader") {
          return false
        }
        if (index === this.pageLayoutList.length - 1 && layout.options.inDocument === "footer") {
          return false
        }
        if (layout.options.inDocument === "anchor") {
          return false
        }
        return true
      }
    },
    pageLayoutList: {
      get() {
        let list = this.$store.state[this.request_prefix].page.pageLayoutList
        if (!list || list.length === 0) {
          let bigScreenHeight = this.$store.state[this.request_prefix].page.children[0].height
          list = [new mockData["primary" + this.request_prefix + "PageLayoutGenerator"](1)]
          list[0].id = 0
          // 新增模式，瀑布流模式
          list[0].layout.rows[0].options.showMultipleLayout = true
          list[0].layout.rows[0].options.waterFlow = true
          if (this.request_prefix === "bigScreen") {
            list[0].options.height = bigScreenHeight
            list[0].layout.rows[0].options.height = bigScreenHeight
          }
          this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: list })
        }
        return list
      },
      set(val) {
        this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: val })
      }
    },
    // 表示通栏里哪些是被隐藏的
    pageLayoutShowList() {
      return this.pageLayoutList.map(layout => (layout.options.isShow ? 1 : 0))
    },
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    isLayoutStage() {
      return this.$store.state[this.request_prefix].page.stageType === "layOut"
    },
    // 新创建的页面第一次进入获取不到showAllScreen
    showAllScreen() {
      // let page = this.$store.state[this.request_prefix].page
      // let showAllScreen = false
      // if (page.hasOwnProperty("showAllScreen")) {
      //   showAllScreen = page.showAllScreen
      // } else {
      //   showAllScreen = false
      // }
      let showAllScreen = this.$store.state.states.showAllScreen
      return !showAllScreen && this.showLeftMenus && this.request_prefix === "stage" ? true : false
    },
    bigScreenAnimateStyle() {
      return function(options) {
        if (this.request_prefix === "bigScreen") {
          return {}
        }
        return {}
      }
    },
    ids() {
      this.isShowAllBtns = false
      return this.$store.state.states.activeID
    },
    pageLayoutId(){
      return parseInt(this.ids.pageLayoutId)
    },
    topElementShow() {
      //判断上方有无标题并且显示
      return function(rect) {
        if (rect?.options?.hasOwnProperty("titleOptions")) {
          let elementOptions = rect.options.titleOptions[0].elementOptions
          let flag = true
          for (let i = 0; i < elementOptions.length; i++) {
            if (elementOptions[i].isShow) {
              flag = false
              break
            }
          }
          return flag
        }
        return true
      }
    },
    stageWidth() {
      if (this.request_prefix === "stage") {
        if (this.stageType === "position") {
          return this.width + "px"
        } else if (typeof this.stageType === "undefined") {
          // pc端编辑区域宽度 以1920作为全屏标准
          return "1920px"
        }
      } else {
        return "100%"
      }
    },
    stageHeight() {
      if (this.stageType === undefined || this.stageType === "position") {
        return this.height + "px"
      } else return "100%"
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    pageLayoutStyle() {
      return function(pageLayout, index) {
        const {
          positionType,
          isFixed,
          enableBayWindow,
          bayWidth,
          bayHeight,
          bayStartPosition,
          anchorWidth,
          inDocument,
          enableLayoutFullScroll
        } = pageLayout.options
        let isShowAnchor = inDocument === "anchor"
        let isGoTop = inDocument === "goTop"
        let width = "100%"
        let position = enableBayWindow || isFixed || isShowAnchor ? "fixed" : positionType ? positionType : ""
        let zIndex = isShowAnchor ? 10001 : this.pageLayoutList.length - index
        if (enableBayWindow) {
          width = `${bayWidth}px`
        } else if (isGoTop) {
          width = `${pageLayout.options.width}px`
        } else if (isShowAnchor) {
          width = `${anchorWidth || 40}px`
        } else if (position === "fixed" || position === "absolute") {
          width = pageLayout.options.isCustomWidth ? pageLayout.options.width ? pageLayout.options.width + pageLayout.options.widthType : "100%" : "100%"
          if(position === "fixed" && this.request_prefix === 'appStage' && width === '100%'){
            width = `${ 414* (this.$store.state.states.zoom || 1)}px`
          }
        }

        let positionStyle = {}
        if (enableBayWindow) {
          let position = bayStartPosition
          let xTrans = position.indexOf("Left") > -1 ? 0 : window.innerWidth - bayWidth - (this.showLeftMenus?220:0)
          let yTrans = position.indexOf("top") > -1 ? 0 : window.innerHeight - bayHeight
          // 右编辑器开启时，需要偏移260px
          if (this.showRightToolbar && position.indexOf("Right") > -1) {
            if (this.request_prefix !== "appStage") {
              xTrans -= 260
            } else {
              xTrans = 414 - bayWidth
            }
          }
          if (position.indexOf("bottom") > -1) {
            yTrans -= 50
          }
          positionStyle = {
            position: "fixed",
            top: 0,
            left: 0,
            transform: `translate(${xTrans}px, ${yTrans}px)`,
            height: `${bayHeight}px`,
          }
          zIndex = 9999
          if (pageLayout.layout.rows[0].rectIds.length === 0) {
            positionStyle.backgroundColor = "#f3f8ff"
          }
        } else if (positionType && (positionType === "fixed" || positionType === "absolute")) {
          zIndex = isShowAnchor ? 10001 : this.pageLayoutList.length + 1
          // 都有定位时 提高头部层级 避免下拉被遮挡
          switch (pageLayout.options.inDocument) {
            case "header": //头部
              zIndex = this.pageLayoutList.length + 2
            default:
          }
          //处理快捷定位后的偏移
          if(pageLayout.options.pxOffset){
            const pxOffset = pageLayout.options.pxOffset
            let top = pageLayout.options.pTop
            let right = pageLayout.options.pRight
            let bottom = pageLayout.options.pBottom
            let left = pageLayout.options.pLeft
            if(["auto","自动"].indexOf(pageLayout.options.pTop) === -1){
              if(typeof pxOffset[0] === "number"){
                top = `calc(${pageLayout.options.pTop} + ${pxOffset[0]}px)`
              }else if(typeof pxOffset[2] === "number"){
                top = `calc(${pageLayout.options.pTop} - ${pxOffset[2]}px)`
              }
              bottom="auto"
            }
            if(["auto","自动"].indexOf(pageLayout.options.pRight) === -1){
              if(typeof pxOffset[1] === "number"){
                right = `calc(${pageLayout.options.pRight} + ${pxOffset[1]}px)`
              }else if(typeof pxOffset[3] === "number"){
                right = `calc(${pageLayout.options.pRight} - ${pxOffset[3]}px)`
              }
              left="auto"
            }
            if(["auto","自动"].indexOf(pageLayout.options.pBottom) === -1){
              if(typeof pxOffset[2] === "number"){
                bottom = `calc(${pageLayout.options.pBottom} + ${pxOffset[2]}px)`
              }else if(typeof pxOffset[0] === "number"){
                bottom = `calc(${pageLayout.options.pBottom} - ${pxOffset[0]}px)`
              }
              top='auto'
            }
            if(["auto","自动"].indexOf(pageLayout.options.pLeft) === -1){
              if(typeof pxOffset[3] === "number"){
                left = `calc(${pageLayout.options.pLeft} + ${pxOffset[3]}px)`
              }else if(typeof pxOffset[1] === "number"){
                left = `calc(${pageLayout.options.pLeft} - ${pxOffset[1]}px)`
              }
              right='auto'
            }
            positionStyle = {
              position: isShowAnchor ? 'absolute':positionType,
              top: top,
              left: left,
              right: right,
              bottom: bottom,
              transform: pageLayout.options.translate ? `translate${pageLayout.options.translate}` : "none"
            }
          }else{
            positionStyle = {
              position:  isShowAnchor ? 'absolute':positionType,
              top: pageLayout.options.pTop,
              left: pageLayout.options.pLeft,
              right: pageLayout.options.pRight,
              bottom: pageLayout.options.pBottom,
              transform: pageLayout.options.translate ? `translate${pageLayout.options.translate}` : "none"
            }
          }
        }
        if(isGoTop) {
          positionStyle.height = `${pageLayout.options.height}px`
        }

        if ((positionType && positionType === "fixed") || (!positionType && isFixed) || enableBayWindow) {
          switch (pageLayout.options.inDocument) {
            case "none":
              break
            case "header": //头部
            case "footer": //底部
              zIndex = 9999
              break
            default:
          }
        }
        if (this.request_prefix === "bigScreen") {
          return {}
        }
        let boxShadow = ""
        if (pageLayout.options.hasOwnProperty("boxShadowH") && typeof pageLayout.options.boxShadowH !== "undefined") {
          if (Array.isArray(pageLayout.options.boxShadowH)) {
            pageLayout.options.boxShadowH.forEach((item, index) => {
              if (index > 0) {
                boxShadow += ","
              }
              let boxShadowColor = pageLayout.options.boxShadowColor
                ? pageLayout.options.boxShadowColor[index]
                : "rgba(255,255,255,0)"
              boxShadow += `${pageLayout.options.boxShadowH[index]}px ${pageLayout.options.boxShadowV[index]}px ${pageLayout.options.boxShadowBlur[index]}px ${pageLayout.options.boxShadowSpread[index]}px ${boxShadowColor}`
            })
          } else {
            boxShadow += `${pageLayout.options.boxShadowH}px ${pageLayout.options.boxShadowV}px ${
              pageLayout.options.boxShadowBlur
            }px ${pageLayout.options.boxShadowSpread}px ${pageLayout.options.boxShadowColor || "rgba(255,255,255,0)"}`
          }
        }
        zIndex = pageLayout.options.hasOwnProperty("zIndex") ? pageLayout.options.zIndex : zIndex
        const styleObj = {
          ...positionStyle,
          zIndex: zIndex,
          position:  isShowAnchor ? 'absolute':position,
          width: width,
          boxShadow: boxShadow
        }
        // 编辑页 fixed 定位使用teleport-comp需要修改成 absolute, 预览页则使用fixed
        if(styleObj.position === "fixed"){
          styleObj.position = "absolute"
          if(this.request_prefix === "appStage"){
            // 只是针对移动端，115是有因为 content_p_helper_app 设置了写死的偏移
            if(styleObj.left === '0%'){
              let offset =  414/2 + 115
              offset = offset * this.$store.state.states.zoom || 1
              styleObj.marginLeft = `calc(50% - ${offset}px)`
            }else if(styleObj.left === '50%'){
              styleObj.marginLeft = - 115 * (this.$store.state.states.zoom || 1) + 'px'
            } else if(styleObj.right === '0%'){
              let offset =  414/2 - 115
              offset = offset * this.$store.state.states.zoom || 1
              styleObj.marginRight = `calc(50% - ${offset}px)`
            }
          }
        }
        // 移动端宽度最多100%
        if(this.request_prefix === "appStage") {
          styleObj.maxWidth = "100%"
        }
        if (
          positionType !== "fixed" &&
          positionType !== "absolute" &&
          (enableLayoutFullScroll || this.pageEnableFullScroll) &&
          !enableBayWindow &&
          ["header", "relativeHeader", "footer", "popover"].indexOf(pageLayout.options.inDocument) == -1
        ) {
          styleObj["minHeight"] = "100vh"
        }
        if (["header", "relativeHeader"].indexOf(pageLayout.options.inDocument) !== -1 && this.isSubHeadPage) {
          styleObj.position = 'relative'
        }
        return styleObj
      }
    },
    getDrawerStyle() {
      return function(pageLayout, index) {
        const {
          opacity,
          borderRadius,
          borderWidth,
          borderStyle,
          borderColor,
          borderIsThemeColor,
          modalTextIsThemeColor,
          modalColorArr
        } = pageLayout.options.drawerParams

        let boxShadow = ""
        let modalColorStyle = {}
        let tmp = []
        if (pageLayout.options.hasOwnProperty("boxShadowH") && typeof pageLayout.options.boxShadowH !== "undefined") {
          if (Array.isArray(pageLayout.options.boxShadowH)) {
            pageLayout.options.boxShadowH.forEach((item, index) => {
              if (index > 0) {
                boxShadow += ","
              }
              let boxShadowColor = pageLayout.options.boxShadowColor
                ? pageLayout.options.boxShadowColor[index]
                : "rgba(255,255,255,0)"
              boxShadow += `${pageLayout.options.boxShadowH[index]}px ${pageLayout.options.boxShadowV[index]}px ${pageLayout.options.boxShadowBlur[index]}px ${pageLayout.options.boxShadowSpread[index]}px ${boxShadowColor}`
            })
          } else {
            boxShadow += `${pageLayout.options.boxShadowH}px ${pageLayout.options.boxShadowV}px ${
              pageLayout.options.boxShadowBlur
            }px ${pageLayout.options.boxShadowSpread}px ${pageLayout.options.boxShadowColor || "rgba(255,255,255,0)"}`
          }
        }
        if (modalTextIsThemeColor) {
          modalColorStyle = {
            color: this.themeColor
          }
        } else {
          if (!(JSON.parse(JSON.stringify(modalColorArr)) == "{}")) {
            modalColorArr.data.stops.forEach(item => {
              tmp.push(item[0] + " " + item[1] * 100 + "%")
            })
            if (modalColorArr.label === "线性渐变") {
              modalColorStyle = {
                color: "transparent",
                backgroundImage: `-webkit-linear-gradient(${modalColorArr.data.angle}deg, ${tmp.join(",")})`
              }
            } else if (modalColorArr.label === "颜色") {
              modalColorStyle = {
                color: modalTextIsThemeColor ? this.themeColor : modalColorArr.data.stops[0][0]
              }
            }
          } else {
            modalColorStyle = {
              color: modalTextIsThemeColor ? this.themeColor : "#fff"
            }
          }
        }
        const direction = pageLayout.options.drawerParams.direction
        let styleObj = {
          boxShadow: boxShadow,
          opacity: opacity,
          "border-top-left-radius": borderRadius[0] + "px",
          "border-top-right-radius": borderRadius[1] + "px",
          "border-bottom-right-radius": borderRadius[2] + "px",
          "border-bottom-left-radius": borderRadius[3] + "px",
          "border-style": borderStyle,
          "border-color": borderIsThemeColor ? this.themeColor : borderColor.color ? borderColor.color : borderColor,
          "border-width": `${borderWidth[0]}px ${borderWidth[1]}px ${borderWidth[2]}px ${borderWidth[3]}px`,
          zIndex: 9999,
          "overflow": "visible" //用于显示工具栏
        }
        switch (direction) {
          case "ttb":
            styleObj.transformOrigin = "left top"
            // styleObj.transform = `scale(1})`
            break
          case "rtl":
            styleObj.transformOrigin = "top right"
            // styleObj.transform = `scale(1})`
            break
          case "btt":
            styleObj.transformOrigin = "left bottom"
            // styleObj.transform = `scale(1})`
            break
          case "ltr":
            styleObj.transformOrigin = "left top"
            // styleObj.transform = `scale(1})`
            break
          default:
            styleObj.transformOrigin = "left top"
            styleObj.transform = `scale(${this.zoom}) translate(-50%, -50%)`
        }
        if (
          pageLayout.options.drawerParams.direction === "rtl" ||
          pageLayout.options.drawerParams.direction === "ltr"
        ) {
          styleObj.width = pageLayout.options.drawerParams.width + "px"
        } else {
          styleObj.height = pageLayout.options.drawerParams.height + "px"
        }
        if (direction === "center") {
          styleObj.width = pageLayout.options.drawerParams.width + "px"
        }
        return Object.assign(styleObj, modalColorStyle)
      }
    },
    getDrawerModalStyle() {
      return function(pageLayout, index) {
        const { modalTextIsThemeColor, modalColorArr } = pageLayout.options.drawerParams
        let modalColorStyle = {}
        let tmp = []
        if (modalTextIsThemeColor) {
          modalColorStyle = {
            color: this.themeColor
          }
        } else {
          if (!(JSON.parse(JSON.stringify(modalColorArr)) == "{}")) {
            modalColorArr.data.stops.forEach(item => {
              tmp.push(item[0] + " " + item[1] * 100 + "%")
            })
            if (modalColorArr.label === "线性渐变") {
              modalColorStyle = {
                color: "transparent",
                backgroundImage: `-webkit-linear-gradient(${modalColorArr.data.angle}deg, ${tmp.join(",")})`
              }
            } else if (modalColorArr.label === "颜色") {
              modalColorStyle = {
                background: modalTextIsThemeColor ? this.themeColor : modalColorArr.data.stops[0][0]
              }
            }
          } else {
            modalColorStyle = {
              background: modalTextIsThemeColor ? this.themeColor : "#fff"
            }
          }
        }
        return modalColorStyle
      }
    },
    getPopperStyle() {
      return function(pageLayout) {
        const popoverParams = pageLayout.options.popoverParams
        const {
          opacity,
          borderRadius,
          borderWidth,
          borderStyle,
          borderColor,
          borderIsThemeColor
        } = popoverParams
        let styleObj = {
          width: popoverParams.width + "px",
          height: popoverParams.height + "px",
          opacity: opacity,
          "border-top-left-radius": borderRadius[0] + "px",
          "border-top-right-radius": borderRadius[1] + "px",
          "border-bottom-right-radius": borderRadius[2] + "px",
          "border-bottom-left-radius": borderRadius[3] + "px",
          "border-style": borderStyle,
          "border-color": borderIsThemeColor ? this.themeColor : borderColor.color ? borderColor.color : borderColor,
          "border-width": `${borderWidth[0]}px ${borderWidth[1]}px ${borderWidth[2]}px ${borderWidth[3]}px`,
          zIndex: 2000,
          "overflow": "visible", //用于显示工具栏
          "transform-origin": "left top",
          transform: "scale("+ this.zoom +")"
        }
        return styleObj
      }
    },
    // 头部和底部固定的时候，上下空出留白
    getContainerStyle() {
      if (!this.pageLayoutList || this.pageLayoutList?.length === 0) {
        return
      }
      let header = this.pageLayoutList[0]?.options.inDocument === "header" ? this.pageLayoutList[0] : undefined
      let footer =
        this.pageLayoutList[this.pageLayoutList.length - 1]?.options.inDocument === "footer"
          ? this.pageLayoutList[this.pageLayoutList.length - 1]
          : undefined
      let top =
        header && header.options.isFixed && header.options.isShow
          ? header.options.height + header.options.padding[0] + header.options.padding[2]
          : 0
      let bottom =
        footer && footer.options.isFixed && footer.options.isShow
          ? footer.options.height + footer.options.padding[0] + footer.options.padding[2]
          : 0
      return {
        paddingTop: top + "px",
        paddingBottom: bottom + "px"
      }
    },
    getLeftNavStyle(){
      return function(layout){
        return {
          width: layout.options.width + layout.options.widthType,
          height: "100vh"
        }
      }
    },
    getPageLayoutStyle() {
      return function(index, layout) {
        const isWaterPageLayout = layout?.layout?.rows?.[0]?.options?.waterFlow === true
        return [
          "page-layout-wrapper",
          this.ids.pageLayoutId == index ? "select-active" : "",
          this.activeIndex == index ? "hover-active" : "",
          isWaterPageLayout && this.isDragover && this.currentDragoverId == layout?.id ? "grid-pageLayout-dragging" : "",
          isWaterPageLayout && this.isDragover && this.dragoverIndex == index ? "grid-pageLayout-drag-over" : "",
          isWaterPageLayout && this.isDragover && this.dragoverIndex - 1 === index ? "grid-pageLayout-drag-over-end" : "",
          !isWaterPageLayout && this.isDragover && this.dragoverIndex == index ? "pageLayout-drag-over" : "",
          !isWaterPageLayout && this.isDragover && this.dragoverIndex - 1 === index ? "pageLayout-drag-over-end" : "",
          layout.options.inDocument === "anchor" ? "anchor-layout" : "",
          layout.options.inDocument === "header" ? "pageLayout-header" : "",
          layout.options.inDocument === "footer" ? "pageLayout-footer" : ""
        ]
      }
    },
    showLeftMenus() {
      return this.$store.state.states.showLeftMenus
    },
    showRightToolbar: {
      get() {
        return this.$store.state.states.showRightToolbar
      },
      set(newVal) {
        this.$store.commit("states/changeShowRightToolbarStatus", newVal)
      }
    },
    showComponentName() {
      return this.$store.state.states.showComponentName
    },
    pageEnableFullScroll() {
      return this.$store.state[this.request_prefix].page.enableFullScroll
    },
    isClonePattern() {
      return this.$store.state.states.isClonePattern || this.$store.state.states.isOrderPattern
    },
    background: {
      get() {
        let curPageLayout = this.pageLayoutList[this.ids.pageLayoutId].options
        let background = curPageLayout.bg
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: curPageLayout.bgColor || "rgba(255,255,255,0)"
          }
        ]
        this.$changeOptionsEV(newBackground, "bg", false, null, {
          container_id: this.ids.container_id,
          pageLayoutId: this.ids.pageLayoutId
        }, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "bg", false, null, {
          container_id: this.ids.container_id,
          pageLayoutId: this.ids.pageLayoutId
        })
      }
    },
    isAdmin() {
      return this.$store.state.states.managerType === 1 ? true : false
    },
    subPagePreviewMode(){
      return this.$store.state.states.subPagePreviewMode
    },
    showShape() {
      let rect = this.getAttrById(this.$store.state[this.request_prefix], this.ids)
      if (!rect) return false
      // 子页面预览模式，不需要此遮罩
      if(this.subPagePreviewMode){
        return false
      }
      if ($(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)?.parents('.pageLayout-header')?.length) return false
      if ($(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)?.parents('.pageLayout-footer')?.length) return false
      if (this.ids.hasOwnProperty('pageLayoutId')) return false
      if (rect.innerElement === "cxAutoLayout" && this.ids.elementInAutoLayoutId !== undefined) {
        rect = rect.elementOptions.find(it => it.elementInAutoLayoutId === this.ids.elementInAutoLayoutId)
      }
      if (!rect) return false
      const shape = rect.shape ? rect.shape : rect.innerElement
      const disableShapes = ["emptyLayoutComponent", "swiperComponent", "cxIframe"]
      const isElement = !(isExist(this.ids.directionIndex) || isExist(this.ids.elementInLayoutId) || isExist(this.ids.swiperContent_id) || isExist(this.ids.elementInSwiperId))
      return !disableShapes.includes(shape) && isElement && this.showRightToolbar && this.request_prefix !== 'bigScreen'
    },
    showEditShape() {
      let isShow = false
      let rect = this.getAttrById(this.$store.state[this.request_prefix], this.ids)
      if (!rect || !isExist(this.ids.rect_id) || this.ids.hasOwnProperty('pageLayoutId')) {
        this.$store.commit("states/changeShowEditShape", false)
        return false
      }
      if ($(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)?.parents('.pageLayout-header')?.length || $(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)?.parents('.pageLayout-footer')?.length) {
        this.$store.commit("states/changeShowEditShape", false)
        return false
      }
      if (rect.innerElement === "cxAutoLayout" && this.ids.elementInAutoLayoutId !== undefined) {
        rect = rect.elementOptions.find(it => it.elementInAutoLayoutId === this.ids.elementInAutoLayoutId)
      }
      if (!rect) return false
      if (!(rect.active || rect.isActive) && !isExist(this.ids.uid) && !isExist(this.ids.swiperContent_id)) {
        this.$store.commit("states/changeShowEditShape", false)
        return false
      }
      const shape = rect.shape ? rect.shape : rect.innerElement
      const complexShapes = ["emptyLayoutComponent", "swiperComponent"]
      const isElement = (isExist(this.ids.directionIndex) || isExist(this.ids.elementInLayoutId) || isExist(this.ids.swiperContent_id) || isExist(this.ids.elementInSwiperId) || isExist(this.ids.uid) )
      // 复杂组件开启聚焦状态
      isShow = (complexShapes.includes(shape) || isElement) && this.showRightToolbar && this.request_prefix !== 'bigScreen'
      this.$store.commit("states/changeShowEditShape", isShow)
      return isShow
    },
    isUseNewPageLayout(){
      const isWaterFall = this.$store.state[this.request_prefix].page.isWaterFall
      return  isWaterFall === 'waterFall' ? true : false
    },
    getBgColor(){
      return function(bg){
        let bgColorSet = bg?.find(item=>item.type === 'color')
        let bgColor = bgColorSet && bgColorSet.color || 'rgba(255,255,255,0)'
        return{
          'background':bgColor
        }
      }
    }
  },
  mounted() {
    sessionStorage.setItem("maxLayoutId", 0)
    this.$nextTick(() => {
      document.addEventListener("keydown", this.keyDelEvent)
      window.addEventListener("wheel", this.setOffset)
    })
    this.initDrawerContoller()
    // 删除掉移动端的关联头部样式（从pc端同步过来的）
    this.delRelativeHeader()
    // 关闭侧边栏通栏后，需要重新渲染，当前通栏才能展示出来
    this.$eventBus.$on(`update-pageLayout`,()=>{
      this.hidePageLayout = true
      setImmediate(()=>{
        this.hidePageLayout = false
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener("wheel", this.setOffset)
    document.removeEventListener("keydown", this.keyDelEvent)
  },
  watch: {
    "ids.pageLayoutId": {
      deep: true,
      handler(newVal, oldVal) {
        this.showColorSelector = false
        if (newVal === null && typeof newVal === "undefined" && oldVal !== null && typeof oldVal !== "undefined") {
          $(".layout-container.set_active").removeClass("set_active active")
          $(".layout-col").removeAttr("data-level")
          $(".page-layout-wrapper").removeAttr("data-level")
        }
        if (newVal && $(`.page-layout-wrapper.select-active`).length > 0) {
          $(`.page-layout-wrapper.select-active`)
            .find(".upper-handle-items .handle-btn-items")
            .removeClass("displayBlock")
        }
      }
    },
    generalPageLayoutLen(newVal, oldVal) {
      // 监听通栏个数变化修改锚点组件
      if (newVal != oldVal) {
        if (this.$store.state[this.request_prefix].page.isShowAnchor) {
          this.changeAnchorBtn()
        }
      }
    }
  },
  methods: {
    parentContextmenuHandle(e){
      this.$emit("parentContextmenuHandle",e)
    },
    delRelativeHeader(){
      // 移动端删除变换头部
      if(this.request_prefix !== 'appStage'){
        return
      }
      let relativeHeaderIndex = this.pageLayoutList.findIndex(layout=>layout.options.inDocument === 'relativeHeader')
      if(relativeHeaderIndex !== -1){
        this.delPageLayoutHandle(relativeHeaderIndex)
      }
    },
    // 判断当前通栏是不是普通通栏
    isGeneralPageLayout(layout) {
      if (layout.options.enableBayWindow) {
        return false
      }
      return true
    },
    setOffset() {
      let element = document.getElementsByClassName("page-layout-wrapper select-active")[0]
      this.offsetTop = element?.getBoundingClientRect().top - 50
      this.offsetBottom = window.innerHeight - element?.getBoundingClientRect().bottom
    },
    handdleClearActive() {
      this.clearActiveInLayoutComponentWithAlignHelper() //处理手动辅助对齐的时候的acitve
      this.clearSwiperElementActive() //处理轮播组件内组件的active
      this.hanleLayoutBacgroundColorClear() //处理布局组件背景色的active
      this.handleClearLeftMenuActive() //处理leftmenu的active
      if (this.$store.state.states.toolBarStatus) this.$store.commit("states/changeToolBarStatus", false)
      if (this.$store.state.states.alignHelperStatus) this.$store.commit("states/changeAlignHelperStatus", false)
      this.$store.commit("states/changeElementType", null)
      this.checkContainerActiveID() //处理ids，一定要放在最后！！！
    },
    //当使用过辅助对齐后，对布局组件内多选过的组件的active清除进行单独处理
    clearActiveInLayoutComponentWithAlignHelper() {
      if (window.localStorage.getItem("oldColsId")) {
        const oldColsId = JSON.parse(window.localStorage.getItem("oldColsId"))
        if (document.getElementById("componentBox_after" + oldColsId)) {
          document.getElementById("componentBox_after" + oldColsId).classList.remove("activeCol")
          window.localStorage.removeItem("oldColsId")
        }
      }

      if (
        JSON.parse(window.localStorage.getItem("oldActiveData")) !== "nothing" &&
        window.localStorage.getItem("selectComponentsIds")
      ) {
        const ids = JSON.parse(window.localStorage.getItem("selectComponentsIds"))
        let param = {
          option_name: "isActive",
          option_val: "delAllActive"
        }
        ids?.forEach(item => {
          ;[param.container_id, param.rect_id, param.uid] = [item.container_id, item.rect_id, item.uid]
          this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
        })
        window.localStorage.removeItem("selectComponentsIds")
      }
    },
    handleClearLeftMenuActive() {
      const acId = this.$store.getters["menu/getActiveMenu"]
      if (acId) this.$store.dispatch("menu/unsetActive", { id: acId })
      if (this.$store.state.states.showLeftMenu) {
        this.$store.commit("states/changeShowLeftMenuStatus", false)
      }
    },
    checkContainerActiveID() {
      if (
        this.ids &&
        (this.ids.container_id !== this.id ||
          Object.keys(this.ids).some(k => k != "container_id" && this.ids[k] !== null))
      ) {
        this.$store.commit("states/changeActiveID", { container_id: this.id })
      }
    },
    clearSwiperElementActive() {
      const clearActive = {
        ...this.ids
      }
      for (const k in clearActive) {
        if (clearActive[k] === null) delete clearActive[k]
      }
      if (clearActive.hasOwnProperty("elementInSwiperId") && clearActive.elementInSwiperId !== null) {
        clearActive.elementInSwiperId = null
        this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", clearActive)
      }
    },
    hanleLayoutBacgroundColorClear() {
      if (JSON.parse(window.localStorage.getItem("oldActiveData")) !== "nothing") {
        let param = { ...JSON.parse(window.localStorage.getItem("oldActiveData")) }
        param.option_val = "delAllActive"
        if (Object.keys(param).length === 3) {
          this.$store.dispatch(this.request_prefix + "/unsetActive", {
            container_id: param.container_id,
            rect_id: param.rect_id
          })
        }
        const clearElementInLayoutStatus =
          param.uid !== null &&
          param.elementInLayoutId !== null &&
          param.hasOwnProperty("uid") &&
          param.hasOwnProperty("uid")
        if (clearElementInLayoutStatus) {
          this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
        }
        window.localStorage.setItem("oldActiveData", JSON.stringify("nothing"))
      }
      let elementType = this.request_prefix === "bigScreen" ? "bigScreenContainer" : "container"
      this.$store.commit("states/changeElementType", elementType)
      if (this.$store.state.states.alignHelperStatus) this.$store.commit("states/changeAlignHelperStatus", false)
    },
    initDataPageIds(newParam) {
      const dataPageIds = this.$store.state.states.getDataPageIds
      const param = { ...dataPageIds, ...newParam }
      if (!!newParam) {
        Object.keys(newParam).forEach(key => (param[key] === newParam[key] ? "" : param[key] === newParam[key]))
        this.$store.commit("states/updateDataPageIds", param)
      }
      return param
    },
    getNewLayoutId() {
      let id = 1
      this.pageLayoutList.forEach(item => {
        id = item.id && item.id >= id ? item.id + 1 : id
      })
      // 不存在的话，默认为null，转为number后为0。之所以要存储在本地，是因为有可能组件已经删除，新增布局，恢复后id会重复
      const maxLayoutId = sessionStorage.getItem("maxLayoutId")
      id = Math.max(id, +maxLayoutId)
      sessionStorage.setItem("maxLayoutId", id + 1)
      return id
    },
    // 添加通栏布局, 打开通栏样式弹框
    addPageLayout(index) {
      this.showPageLayoutStyle = true
      this.curPageLayoutIndex = index
    },
    keyDelEvent() {
      if (!this.ids.hasOwnProperty("pageLayoutId")) {
        return
      }
      let idArr = this.ids.pageLayoutId
      idArr.toString().split("_")
      if (idArr.length > 1) {
        // 布局返回
        return
      }
      if (this.generalPageLayoutLen < 2) {
        return
      }
      let key = window.event.keyCode
      if (key === 46) {
        // 根据当前选中pageLayoutId获取当前选中通栏
        //  头部不删除  底部不删除 锚点不删除  飘窗不删除
        let curPageLayout = this.pageLayoutList[this.ids.pageLayoutId]
        let type = curPageLayout.options.inDocument
        // 排除用fixed定位的通栏、被隐藏的通栏、锚点通栏
        if (type === "header" || type === "footer" || type === "anchor" || curPageLayout.options.enableBayWindow) {
          return
        }
        if (!sessionStorage.getItem("isDeletingConfirm")) {
          this.delPageLayout(this.ids.pageLayoutId)
        }
      }
    },
    // 清空当前通栏
    cleanPageLayout(index) {
      this.$confirm("确认清空吗？", "", {
        confirmButtonText: "清空",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认清空吗？</p>",
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          // isOnlyCleanRect   判断是否只是单纯的清空内容
          this.delPageLayoutHandle(index, true)
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "清空成功"
          })
        })
        .catch(() => {
        })
    },
    // 删除通栏布局
    delPageLayout(index) {
      sessionStorage.setItem("isDeletingConfirm", true)
      // 记录下删除通栏和子元素信息
      this.$confirm("确认删除吗？", "", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          sessionStorage.removeItem("isDeletingConfirm")
          this.delPageLayoutHandle(index)
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "删除成功"
          })
        })
        .catch(() => {
          sessionStorage.removeItem("isDeletingConfirm")
        })
    },
    // 删除通栏操作  isOnlyCleanRect  判断是否是单纯的只清空内容
    delPageLayoutHandle(index, isOnlyCleanRect) {
      this.$addHistory({
        type: "delete",
        stateType: "deletePageLayout",
        payload: {
          container_id: 0,
          pageLayoutId: this.pageLayoutList[index].id,
        }
      })
      this.delElementHandle(this.pageLayoutList[index], isOnlyCleanRect)
      if (!isOnlyCleanRect) {
        this.pageLayoutList.splice(index, 1)
        this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: this.pageLayoutList })
        // 删除通栏之后将激活项转移到前面一个通栏上
        this.activeIndex = index > 0 ? index - 1 : index + 1
        this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: this.activeIndex })
        this.$store.commit("states/changeElementType", "cxPageLayout")
      } else {
        this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: this.pageLayoutList })
      }
    },
    // 新增当前通栏到移动端
    addToAppPageLayout(index, id, layout) {
      // this.setPageLayout(layout, index)
      // setTimeout(() => {
        let data = JSON.parse(JSON.stringify(this.$store.state.stage))
        let newPageLayout = data.page.pageLayoutList[index]
      if(['header','footer','relativeHeader'].indexOf(newPageLayout.options.inDocument)>-1){
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "特殊组件，不允许此类操作",
          type: "warning"
        })
        return
      }
        this.$store.dispatch("appStage/initData", { data, newPageLayout, type: "new" })
      // }, 50);
    },
    // 同步当前通栏到移动端
    syncPageLayout(index, layout, unboundAppType) {
      // 是否 同步原始样式
      if(unboundAppType == 1){
        //同步原始样式
        this.pageLayoutList[index].options.unboundApp = false
      }else{
        //同步时 使用移动端对应的绑定样式
        this.pageLayoutList[index].options.unboundApp = true
      }
      // if(['header','footer','relativeHeader'].indexOf(this.pageLayoutList[index].options.inDocument)>-1){
      //   this.$message({
      //     customClass: "bigScreen_msg_backGroud",
      //     duration: 3000,
      //     message: "特殊组件，不允许此类操作",
      //     type: "warning"
      //   })
      //   return
      // }
      this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: this.pageLayoutList })
      // this.setPageLayout(layout, index)
      // setTimeout(() => {
        let data = JSON.parse(JSON.stringify(this.$store.state.stage))
        let newPageLayout = data.page.pageLayoutList[index]
        this.$store.dispatch("appStage/initData", { data, newPageLayout, type: "edit" })
      // }, 50);
    },
    delElementHandle(cellVal, isOnlyCleanRect) {
      // let rectIds = cellVal.rectIds ? JSON.parse(JSON.stringify(cellVal.rectIds)) : []
      let cellValRectIds = cellVal.rectIds || []
      let rectIds = isOnlyCleanRect ? cellValRectIds : JSON.parse(JSON.stringify(cellValRectIds))
      rectIds.forEach((item, index) => {
        let param = {
          container_id: this.id,
          rect_id: item,
          record: false
        }
        this.$store.dispatch(this.request_prefix + "/deleteElement", param)
      })
      cellVal.rectIds = []
      cellVal.layout.rows.forEach(item => {
        if ((item.rectIds && item.rectIds.length > 0) || item.layout) {
          this.delElementHandle(item, isOnlyCleanRect)
        }
      })
      cellVal.layout.cols?.forEach(item => {
        if ((item.rectIds && item.rectIds.length > 0) || item.layout) {
          this.delElementHandle(item, isOnlyCleanRect)
        }
      })
    },
    dragoverEv(flag, isActive) {
      let dropOverCell = sessionStorage.getItem("dropOverCell")
      if (dropOverCell) {
        // 抽屉的拖拽直接返回
        //  当前拖拽在布局上方
        return
      }

      this.isDragover = isActive ?? true
      console.log('this.isDragover的值是:', this.isDragover)
      this.dragoverIndex = this.getInsertIndex(flag)
    },
    wrapperDragoverEv(flag) {
      let dropOverCell = sessionStorage.getItem("dropOverCell")
      if (dropOverCell) {
        // 抽屉的拖拽直接返回
        //  当前拖拽在布局上方
        return
      }
      if (this.isUseNewPageLayout) return
      this.isDragover = true
      this.dragoverIndex = this.getInsertIndex(flag)
    },
    setPageLayoutActive(index) {
      // 如果当前页面有正在拖拽的元素禁止触发外层hover
      if ($(".dragging").length > 0) return
      // 从左侧菜单栏拖入组件的时候 不激活通栏
      let isDragging = sessionStorage.getItem("isDragging")
      if (!isDragging) {
        this.activeIndex = index
      }
    },
    setPageLayoutunActive(index) {
      // 如果当前页面有正在拖拽的元素禁止触发外层hover
      if ($(".dragging").length > 0) return
      if (this.ids.pageLayoutId != index) {
        this.activeIndex = null
        this.isFolding = false
        this.unfoldFlag = false
        this.isFoldAnimate = false
      }
    },
    // 将通栏样式保存为系统样式
    savePageLayoutStyle(layout, index, isCollect) {
      // this.setPageLayout(layout, index)
      this.$emit("openSystemLayoutDialog", layout, isCollect)
    },
    // 打开通栏设置项
    setPageLayout(layout, index) {
      if (this.ids.pageLayoutId == index) return
      if (this.$store.state.states.isClonePattern) {
        return
      }
      this.isShowAllBtns = false
      this.activeIndex = index
      //  取消自动布局内元素选中状态
      if (this.ids.hasOwnProperty("container_id") && this.ids.hasOwnProperty("rect_id")) {
        let rect = this.getAttrById.call(
          this,
          this.$store.state[this.request_prefix],
          {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id
          },
          "rect"
        )
        this.$store.dispatch(this.request_prefix + "/unsetActive", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
        })
        if (rect && rect.shape === "cxAutoLayout") {
          this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
          })
        }
      }
      this.$store.commit("states/changeShowRightToolbarStatus", true)
      this.$store.commit("states/changeRightBtnStatu", false)
      if (this.isBigScreenPreview()) return
      this.isFolding = this.unfoldFlag ? true : false
      this.unfoldFlag = false
      this.isFoldAnimate = true
      document.getElementsByClassName("layout-container active")[0]?.classList.remove("active")
      document.getElementsByClassName("layout-container set_active")[0]?.classList.remove("set_active")
      document.getElementsByClassName("page-layout-wrapper hide")[0]?.classList.remove("hide")

      let pageLayoutWrapper = document.getElementsByClassName("page-layout-wrapper")
      for (let i = 0; i < pageLayoutWrapper.length; i++) {
        if (pageLayoutWrapper[i].getAttribute("data-level")) {
          pageLayoutWrapper[i].removeAttribute("data-level")
          break
        }
      }
      let layoutCol = document.getElementsByClassName("layout-col")
      for (let j = 0; j < layoutCol.length; j++) {
        if (layoutCol[j].getAttribute("data-level")) {
          layoutCol[j].removeAttribute("data-level")
          break
        }
      }
      // document.getElementsByClassName("page-layout-wrapper")[0]?.removeAttribute("data-level")
      // document.getElementsByClassName("layout-col")[0]?.removeAttribute("data-level")
      const timer = setTimeout(() => {
        this.isFolding = false
        this.isFoldAnimate = false
        clearTimeout(timer)
      }, 300)
      this.$store.commit("states/changeLogicTextDynamicId", "")
      this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: index })
      this.$store.commit("states/changeElementType", "cxPageLayout")
      this.$nextTick(() => {
        this.setOffset()
      })
    },
    // 上移通栏
    upPageLayout(layout, index) {
      this.$addHistory({
        type: "update",
        stateType: "movePageLayout",
        payload: {
          container_id: 0,
          pageLayoutId: this.pageLayoutList[index].id,
          moveDirection: "up"
        }
      })
      this.pageLayoutList.splice(index, 1)
      this.pageLayoutList.splice(index - 1, 0, layout)
      // 保留原有激活的通栏
      this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: index - 1 })
      this.$store.commit("states/changeElementType", "cxPageLayout")
    },
    // 下移通栏
    downPageLayout(layout, index) {
      this.$addHistory({
        type: "update",
        stateType: "movePageLayout",
        payload: {
          container_id: 0,
          pageLayoutId: this.pageLayoutList[index].id,
          moveDirection: "down"
        }
      })
      this.pageLayoutList.splice(index, 1)
      this.pageLayoutList.splice(index + 1, 0, layout)
      // 保留原有激活的通栏
      this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: index + 1 })
      this.$store.commit("states/changeElementType", "cxPageLayout")
    },
    // 复制通栏
    async copyPageLayout(layout, index) {
      this.newRectIds = []
      this.hasAddedLen = 0
      this.newRectLen = 0
      if(['header','footer','relativeHeader'].indexOf(layout.options.inDocument)>-1){
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "特殊组件，不允许此类操作",
          type: "warning"
        })
        return
      }
      let tempLayout = JSON.parse(JSON.stringify(layout))
      this.getRectLen(tempLayout)
      tempLayout.id = this.getNewLayoutId()
      let gridLayout = tempLayout.layout.rows[0]?.options?.gridLayout
      let gridLayoutIds = []
      if(gridLayout){
        gridLayout.forEach((item,index)=>{
          let newId = this.uuid.v1()
          gridLayoutIds.push({
            oldId: item.i,
            newId: newId
          })
          item.i=newId
        })
      }
      this.pageLayoutList.splice(index, 0, tempLayout)
      this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: this.pageLayoutList })
      this.$addHistory({
        type: "add",
        stateType: "addPageLayout",
        payload: {
          container_id: 0,
          pageLayoutId: this.pageLayoutList[index].id,
          index
        }
      })
      // todo  通栏里的样式要重新写入
      await this.getRect(tempLayout,gridLayoutIds,undefined,true)
    },
     getRectLen(col) {
      if (col.layout.rows?.length > 0) {
        col.layout.rows?.forEach(layout => {
          this.getRectLen(layout)
        })
      } else if (col.layout.cols?.length) {
        col.layout.cols?.forEach(layout => {
          this.getRectLen(layout)
        })
      } else {
        if (col.rectIds?.length > 0) {
          this.newRectLen =  this.newRectLen+ col.rectIds.length
        }
      }
    },
    // 获取rect
    async getRect(col,gridLayoutIds, parentRectId,isIgnoreAnimate) {
      if (col.layout.rows?.length > 0) {
        col.layout.rows?.forEach(layout => {
          this.getRect(layout,gridLayoutIds, parentRectId,isIgnoreAnimate)
        })
      } else if (col.layout.cols?.length) {
        col.layout.cols?.forEach(layout => {
          this.getRect(layout,gridLayoutIds, parentRectId,isIgnoreAnimate)
        })
      } else {
        if (col.rectIds?.length > 0) {
          for (let i = 0; i < col.rectIds.length; i++) {
            let rectAttr = this.getAttrById(
              this.$store.state[this.request_prefix],
              {
                container_id: 0,
                rect_id: col.rectIds[i]
              },
              "rect"
            )
            let gridLayoutId
            if (gridLayoutIds) {
              gridLayoutId = gridLayoutIds?.find(item=>item.oldId === rectAttr.i)?.newId
            }
              await this.addNewRect({
                rectAttr: rectAttr,
                cellRect: col.rectIds,
                index: i,
                type: "edit",
                isClone: true,
                gridLayoutId:gridLayoutId,
                parentRectId: parentRectId,
                ignoreAnimate: true // 此处的动画关系 需要在所有的组件都加入之后再处理
              })
          }
        }
      }
    },
    // 新加入rect
    async addNewRect(param) {
      let rectAttr = JSON.parse(JSON.stringify(param.rectAttr))
      let oldRectId = rectAttr.rect_id
      let rect_id
      rectAttr.i = param.gridLayoutId
      // 删除组件的 "滚动到可见的动画"
      // delAnimateGroup(rectAttr.options)
      deepChangeUid(rectAttr)
      if (isExist(rectAttr.options?.parentRectId) && isExist(param.parentRectId)) {
        rectAttr.options.parentRectId = param.parentRectId
      }
      // 单元格里不能放布局通栏
      const baseComponent = this.isUseNewPageLayout ? this.waterFlowBaseComponent : this.baseComponent
      if (param.type === "new") {
        if (
          baseComponent.indexOf(rectAttr.shape) > -1 ||
          // 特殊情况，自由布局组件，带“ListPageSearchComponentPlugin”插件的组件，作为基础组件处理
          (rectAttr.options.pluginName && rectAttr.options.pluginName.indexOf("ListPageSearchComponentPlugin") > -1)
        ) {
          // 基础元素，支持在col内自由拖拽
          rectAttr.options.top = 0
          rectAttr.options.left = 0
          rectAttr.options.zIndex = 2
          // 拖入横向标签布局时不重置布局的高度
          if (!(rectAttr.shape === "cxTabs" && rectAttr.options.isPageLayoutTabs)) {
            this.changeCellSize(param.parentIndex, undefined, rectAttr.options.height)
          }
        } else {
          this.changeCellSize(param.parentIndex, undefined, rectAttr.options.height)
          // 一个col里面只能放一个组件（非基础元素）
          rectAttr.options.top = 0
          rectAttr.options.left = 0
          rectAttr.options.width = 100
          rectAttr.options.widthType = "%"
          rectAttr.options.zIndex = 1
          rectAttr.options.draggable = false
          rectAttr.options.resizable = false
        }
      }
      const containerOpt = this.getAttrById(
        this.$store.state[this.request_prefix],
        { container_id: this.id },
        "container"
      )
      // 如果当前数据中存在appId判断当前组件是否是系统保存好的样式
      if (rectAttr.options.myFetchParam?.appId || rectAttr.options.appId) {
        //更新appid
        const appId = rectAttr.options.appId ? rectAttr.options.appId : rectAttr.options.myFetchParam?.appId
        // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
        const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
        const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
        this.$styleToSaveModule("31CB73E03E24BBFF", "临时", appId, param.isClone, isSearchComponent, isNavComponent)
          .then(res => {
            if (!!res.appId) {
              // 没有myfetchparam的组件 比如搜索组件 更新appId
              rectAttr.options.appId = res.appId
              // 克隆的组件需要将原组件的子页面相关id清空
              if (param.isClone) {
                delete rectAttr.options.detailPageId
                delete rectAttr.options.detailPageTemplateEncId
                delete rectAttr.options.listPageId
                delete rectAttr.options.listPageTemplateEncId
              }
              const params = {
                containerID: this.id,
                data: rectAttr,
                ignoreAnimate: param.ignoreAnimate
              }
              // 先删除后面再添加，避免add过程失败，复制的组件id未变
              let newIndex = param.index
              param.cellRect.splice(newIndex, 1)
              this.$store.dispatch(this.request_prefix + "/addElement", params)

              const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
                container_id: this.id
              }).children
              let _rect_id = -1
              if (allRects.length > 0) {
                _rect_id = smartMathMax(
                  ...allRects.map(function(o) {
                    return o.rect_id
                  })
                )
              }
              rect_id = _rect_id
              this.activateEv(this.id, rect_id, rectAttr.shape)
              if (typeof newIndex !== "undefined") {
                param.cellRect.splice(newIndex, 0, rect_id)
              } else {
                param.cellRect.push(rect_id)
              }
              this.newRectIds.push({
                oldRectId: oldRectId,
                newRectId: rect_id
              })
              if(param.ignoreAnimate){
                this.handleCopyPageLayoutAnimate()
              }

            }
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        const params = {
          containerID: this.id,
          ignoreAnimate: param.ignoreAnimate,
          data: rectAttr
        }
        this.$store.dispatch(this.request_prefix + "/addElement", params)
        // this.activateEv(this.id, rect_id, rectAttr.shape)
        let newIndex = param.index
        const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.id
        }).children
        // let _rect_id = allRects.length ? allRects[allRects.length - 1].rect_id : -1
        let _rect_id = -1
        if (allRects.length > 0) {
          _rect_id = smartMathMax(
            ...allRects.map(function(o) {
              return o.rect_id
            })
          )
        }
        rect_id = _rect_id
        if (typeof newIndex !== "undefined") {
          param.cellRect.splice(newIndex, 1, rect_id)
        } else {
          param.cellRect.push(rect_id)
        }
        this.newRectIds.push({
          oldRectId: oldRectId,
          newRectId: rect_id
        })
        this.activateEv(this.id, rect_id, rectAttr.shape)
        if(param.ignoreAnimate){
          this.handleCopyPageLayoutAnimate()
        }
      }
      //如果是自由布局组件 那就要检测自由布局组件内的组件是否有appid
      handleChildAppid.call(this,rectAttr,this.id)
      // 如果是带标签的布局组件，里面的组件的id 需要处理
      if(rectAttr.shape === 'cxPageLayoutComponent'){
        this.addRectInPageLayoutComponent(rectAttr, rectAttr.rect_id)
      }
    },
    // 复制通栏时，组件添加完毕之后处理动画关系
    handleCopyPageLayoutAnimate(){
      this.hasAddedLen++
      if (this.hasAddedLen === this.newRectLen) {
        //所有的组件都替换到最新的rectId 之后，重新梳理动画关系
        editAnimateAddLayout(this.$store.state[this.request_prefix], this.newRectIds, this.id)
      }
    },
    async addRectInPageLayoutComponent(rectAttr, parentRectId){
      await this.getRect(rectAttr.options.layout, "", parentRectId)
    },
    contextmenuHandle(e) {
      if(e.target.className === "icon handle-move"){
        $(e.target).parents(".grid-item-content").trigger("click")
      }else if(e.target.className.includes && e.target.className.includes("vdr_shade")){
        $(e.target.parentElement.getElementsByClassName("rect")[0]).trigger("mousedown")
      } else if(e.target.className.includes && e.target.className.includes("layout-cell-container")){
        $(e.target).trigger("click")
      }
      // setTimeout(()=>{
      //   $(e.target.parentElement.getElementsByClassName("rect")[0]).trigger("mouseup")
      // })
      if (this.isBigScreenPreview()) return
      if (e.button === 2) {
        setTimeout(()=>{
          this.$emit("contextmenu", e)
        },500)
      }
    },
    resetRectAttrOpt(childItem, _attribute) {
      this.needHid = true
      let layoutUidMap = {}
      childItem.encId ? (_attribute.moduleId = childItem.encId) : ""
      childItem.typeId ? (_attribute.typeId = childItem.typeId) : ""
      // this.doAdd = true
      //鼠标移动处理
      if (this.request_prefix === "appStage" && _attribute.options.width > 414) {
        _attribute.options.width = 414
      }
      if (_attribute.shape === "layoutComponent" || "emptyLayoutComponent") {
        //递归修改uid 把menu里的默认uid（会导致cols的id值重复）修改为随机生成的uid
        layoutUidMap = deepChangeUid(_attribute)
      }
      _attribute.options.layoutUidMap = layoutUidMap
      return JSON.stringify(_attribute)
    },
    setDefaultGridLayout(layoutList, type,defaultH) {
      layoutList.layout.rows[0].options.showMultipleLayout = true
      layoutList.layout.rows[0].options.waterFlow = true
      // 新拖入布局1的时候不生成栅格
      // if(noGrid){
      //   return
      // }
      if (type != 1) {
        layoutList.layout.rows[0].layout.rows = []
        layoutList.layout.rows[0].layout.cols = []
      }
      // type值 1为1  2为1:1  9为1:1:1
      const colNum = 48  // 与waterFall的colNum保持一致
      const defaultHeight = defaultH || 500
      let gridLayoutId = this.uuid.v1()
      let layout = [{
        w: colNum,
        h: defaultHeight,
        x: 0,
        y: 0,
        i: gridLayoutId
      }]
      switch (Number(type)) {
        case 1:
          break;
        case 2:
          layout = [{
            w: colNum / 2,
            h: defaultHeight,
            x: 0,
            y: 0,
            i: this.uuid.v1()
          }, {
            w: colNum / 2,
            h: defaultHeight,
            x: colNum / 2,
            y: 0,
            i: this.uuid.v1()
          }]
          break;
        case 9:
          layout = [{
            w: colNum / 3,
            h: defaultHeight,
            x: 0,
            y: 0,
            i: this.uuid.v1()
          }, {
            w: colNum / 3,
            h: defaultHeight,
            x: colNum / 3,
            y: 0,
            i: this.uuid.v1()
          }, {
            w: colNum / 3,
            h: defaultHeight,
            x: colNum * 2 / 3,
            y: 0,
            i: this.uuid.v1()
          }]
          break;
        default:
      }
      layoutList.layout.rows[0].options.gridLayout = layout
      layoutList.layout.rows[0].options.isNewVersion = true
      return {
        gridLayoutId: gridLayoutId
      }
    },
    checkIsDisableSyncTab(pluginName, name, menuName) {
      // 特殊组件不走同步规则
      const hideNames = ["searchComponentPlugin", "loginLayoutComponent", "loginEngineComponentPlugin", "appNavPlugin", "ListPageSearchComponentPlugin"]
      if (pluginName?.length) {
        return pluginName?.length
          ? pluginName.find(it => {
              return hideNames.find(_it => _it === it)
            })
          : false
      } else if (name === "超星头像" || menuName === "列表页搜索") {
        return true
      } else return false
    },
    async drop2(e) {
      console.log("iniin")
      sessionStorage.removeItem("isDragging")
      sessionStorage.removeItem("dropOverCell")
      this.isDragover = false
      this.dragoverIndex = null
      this.currentDragoverId = null
      if (this.isBigScreenPreview()) return
      if (e.target.parentNode.classList[0] !== "componentBox_after") {
        let rectAttr = e.dataTransfer.getData("rectAttribute")
        let childItemInfo = sessionStorage.getItem("childItemInfo")
        childItemInfo = JSON.parse(childItemInfo)
        if (childItemInfo.childItemName === "收藏") {
          rectAttr = JSON.parse(rectAttr)
          const _attribute = await getSyetemModuleJson(rectAttr.encId)
          rectAttr = JSON.stringify(_attribute)
        } else if (!rectAttr || rectAttr.length === 0 || rectAttr === "undefined" || !JSON.parse(rectAttr).shape) {
          if (childItemInfo.childItemTypeId) {
            let childItem = await getFirstModuleEncId.call(this, childItemInfo.childItemTypeId)
            let type = childItem.content.shape
            let attribute = childItem.content
            const _attribute = JSON.parse(JSON.stringify(attribute))
            rectAttr = this.resetRectAttrOpt(childItem, _attribute)
          } else {
            return
          }
        }
        rectAttr = JSON.parse(rectAttr)
        if (rectAttr.shape === "emptyLayoutComponent" && !rectAttr.options?.categoryMode && !this.checkIsDisableSyncTab(rectAttr?.options?.pluginName, rectAttr?.options?.name, rectAttr?.options?.menuName)) {
          rectAttr.options.categoryMode = CATEGORY_MODE.SAME
          rectAttr.options.rows.splice(1)
        }
        if (childItemInfo && childItemInfo.childItemTypeId) {
          rectAttr.options.componentTypeName = childItemInfo.childItemTypeName
          rectAttr.options.componentTypeId = childItemInfo.childItemTypeId
          rectAttr.options.name = childItemInfo.childItemTitle ? childItemInfo.childItemTitle : childItemInfo.childItemName
        }
        let insertIndex = this.getInsertIndex(e)
        if (rectAttr.shape === "cxPageLayout") {
          let layoutList = new mockData["primary" + this.request_prefix + "PageLayoutGenerator"](rectAttr.options.type)
          layoutList.id = this.getNewLayoutId()
          if(this.isUseNewPageLayout){
            this.setDefaultGridLayout(layoutList, rectAttr.options.type)
          }
          this.pageLayoutList.splice(insertIndex, 0, JSON.parse(JSON.stringify(layoutList)))
          this.$addHistory({
            type: "add",
            stateType: "addPageLayout",
            payload: {
              container_id: 0,
              pageLayoutId: layoutList.id,
              index: insertIndex
            }
          })
          this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: insertIndex })
          this.$store.commit("states/changeElementType", "cxPageLayout")
          if (this.pageLayoutList[insertIndex]?.options?.isShowTabs) {
            let param = {
              active: false,
              draggable: true,
              hoverZIndex: 1,
              parentLim: true,
              resizable: true,
              shape: "cxTabs",
              options: JSON.parse(JSON.stringify(cxTabsState.children[0].attribute.options))
            }
            param.options.isPageLayoutTabs = true
            param.options.isNoSyncData = true
            let colRectIds = this.pageLayoutList[insertIndex].layout.rows[0].layout.rows[0].rectIds
            let isShowVerticalTabs = this.pageLayoutList[insertIndex]?.options?.isShowVerticalTabs
            let rowRectIds = null
            if (isShowVerticalTabs) {
              param.options.width = 100
              param.options.height = 200
              param.options.isPageLayoutVerticalTabs = true
              rowRectIds = this.pageLayoutList[insertIndex].layout.rows[0].layout.rows[0].layout.cols[0].rectIds
            } else {
              param.options.width = 300
              param.options.height = 44
            }
            this.addNewRect({
              rectAttr: param,
              cellRect: isShowVerticalTabs ? rowRectIds : colRectIds,
              index: 0,
              type: "new",
              isClone: false,
              parentIndex: insertIndex
            })
          }
        } else {
          this.addNewPageLayout({
            type: 0, //默认添加第一个布局样式
            insertIndex: insertIndex,
            rectAttr: rectAttr
          })
        }
        this.activeIndex = insertIndex
      }
    },
    async changeAnchorBtn() {
      let pageLayoutList = this.pageLayoutList
      // 排除用fixed定位的通栏、被隐藏的通栏、锚点通栏
      let pageListLen = 0
      this.pageLayoutList.forEach(pageLayout => {
        let type = pageLayout.options.inDocument
        if (type !== "anchor" && pageLayout.options.position !== "fixed" && pageLayout.options.isShow) {
          pageListLen++
        }
      })
      for (let i = 0; i < pageLayoutList?.length; i++) {
        const item = pageLayoutList[i]
        if (item.options.inDocument === "anchor") {
          let rectIds = item?.layout?.rows[0]?.rectIds
          let rectIdsLen = item?.layout?.rows[0]?.rectIds?.length
          let elementList = []
          if (rectIds) {
            rectIds.forEach(item => {
              elementList.push(
                this.$store.state[this.request_prefix].page.children[0].children.find(rect => rect.rect_id === item)
              )
            })
          }
          if (pageListLen > rectIdsLen - 2) {
            // 添加锚点个数
            let index = rectIdsLen > 2 ? rectIdsLen - 2 : 0
            let len = pageListLen - (rectIdsLen - 2)
            let param = {
              active: false,
              draggable: false,
              hoverZIndex: 1,
              parentLim: true,
              resizable: true,
              shape: "cxButton",
              options: JSON.parse(JSON.stringify(elementList[0]?.options))
            }
            for (var j = 0; j < len; j++) {
              if (Number(index + 1 + j) < 10) {
                param.options.content = "0" + Number(index + 1 + j)
              } else {
                param.options.content = Number(index + 1 + j)
              }
              await this.addNewRect({
                rectAttr: param,
                cellRect: rectIds,
                index: Number(index + j),
                type: "new",
                isClone: false,
                parentIndex: i
              })
            }
          } else if (pageListLen < rectIdsLen - 2) {
            // 此时说明是删除通栏
            let index = rectIdsLen > 3 ? rectIdsLen - 3 : 0
            rectIds.splice(index, 1)
          }
        }
      }
    },
    // 拖入应用之后改变外层壳子的尺寸
    changeCellSize(parentIndex, width, height) {
      if (this.request_prefix === "bigScreen" || this.pageLayoutList[parentIndex].options.isShowLayoutCanvas || this.pageLayoutList[parentIndex].options.isAccordionLayout) {
        // 大屏的格子高度不随组件改变
        // 瀑布流模式，通栏高度另外计算
        return
      }
      let targetHeight
      if (!width) {
        // targetHeight = Math.max(height ,this.pageLayoutList[parentIndex].options.height)
        targetHeight = height
      } else {
        targetHeight = this.$el.getBoundingClientRect().width * (height / width)
      }
      this.pageLayoutList[parentIndex].options.height = targetHeight
      this.pageLayoutList[parentIndex].layout.rows[0].options.height = targetHeight
    },
    getInsertIndex(e) {
      let _this = this
      let top = Number(e.offsetY) * this.zoom //鼠标在当前元素上的位置
      let _index = 0
      let targetPageLayout
      if ([].find.call(e.target.classList, it => it === "page-layout-wrapper")) {
        targetPageLayout = [e.target]
      } else {
        targetPageLayout = this.getParentNode(e.target, [], "page-layout-wrapper")
        top += e.target.offsetTop * this.zoom
      }
      let targetPosition = targetPageLayout[0].getBoundingClientRect()
      let parentNode = this.getParentNode(e.target, [], "myContainer")
      if (parentNode.length === 0) {
        _index = _this.options.elementOptions.length
        return _index
      }
      //垂直方向排列
      const curId = Number(targetPageLayout[0].getAttribute("layoutindex"))
      _index = _this.pageLayoutList.findIndex(item => {
        return item.id === curId
      })
      this.currentDragoverId = _this.pageLayoutList[_index]?.id
      _index = top < targetPosition.height / 2 ? _index : _index + 1 //超过元素高度一半显示在下方，否则显示在上方
      let pageLayoutListLen = this.pageLayoutList.length
      let firstPageLayoutOption = this.pageLayoutList[0].options
      let lastPageLayoutOption = this.pageLayoutList[this.pageLayoutList.length - 1].options
      if (
        (_index === 0 && firstPageLayoutOption.inDocument === "header") ||
        (firstPageLayoutOption.inDocument === "header" && !firstPageLayoutOption.isShow)
      ) {
        _index++
      }
      if (_index === pageLayoutListLen && lastPageLayoutOption.inDocument === "footer" && lastPageLayoutOption.isShow) {
        _index--
      }
      return _index
    },
    //  将组件拖入空白处，生成新的通栏布局+组件
    addNewPageLayout(param) {
      let layoutList = new mockData["primary" + this.request_prefix + "PageLayoutGenerator"](param.type)
      layoutList = JSON.parse(JSON.stringify(layoutList))
      layoutList.id = this.getNewLayoutId()
      if (this.request_prefix === "appStage") {
        // 移动端的通栏 设置默认间距 上下20  左右16
        layoutList.options.padding = [20, 16, 20, 16]
      }
      // todo  添加组件加载loading
      // 列表页，详情页使用旧的布局模式
      let dragType = param.rectAttr.shape
      const loadingType = ['emptyLayoutComponent','layoutComponent','swiperComponent']
      // let isNeedLoading = false
      // if(loadingType.indexOf(dragType)>-1){
      //   // 添加loading效果
      //   isNeedLoading = true
      // }
      if(!this.isUseNewPageLayout){
        this.pageLayoutList.splice(param.insertIndex, 0, JSON.parse(JSON.stringify(layoutList)))
        let colRectIds = this.pageLayoutList[param.insertIndex].layout.rows[0].rectIds
        if (param.rectAttr.shape === "emptyLayoutComponent"  && !param.rectAttr?.options?.categoryMode && !this.checkIsDisableSyncTab(param.rectAttr?.options?.pluginName, param.rectAttr?.options?.name, param.rectAttr?.options?.menuName)) {
          // 设置自由布局为自动标签同步模式
          if(param.rectAttr.options) {
            param.rectAttr.options.categoryMode = CATEGORY_MODE.SAME
            param.rectAttr.options.rows.splice(1)
          }
        }
        this.addNewRect({
          rectAttr: param.rectAttr,
          cellRect: colRectIds,
          index: 0,
          type: "new",
          isClone: false,
          parentIndex: param.insertIndex
        })
      }else{
        // 新增模式，新增通栏，布局都开启瀑布流模式
        let gridLayoutId = this.setDefaultGridLayout(layoutList, param.type,param.rectAttr.options.height+20).gridLayoutId
        this.pageLayoutList.splice(param.insertIndex, 0, JSON.parse(JSON.stringify(layoutList)))
        if (param.rectAttr.shape === "cxPageLayout") {
           return
        }
        let colRectIds = this.pageLayoutList[param.insertIndex].layout.rows[0].rectIds
        if (param.rectAttr.shape === "emptyLayoutComponent"  && !param.rectAttr?.options?.categoryMode && !this.checkIsDisableSyncTab(param.rectAttr?.options?.pluginName, param.rectAttr?.options?.name, param.rectAttr?.options?.menuName)) {
          // 设置自由布局为自动标签同步模式
          if(param.rectAttr.options) {
            param.rectAttr.options.categoryMode = CATEGORY_MODE.SAME
            param.rectAttr.options.rows.splice(1)
          }
        }
        this.addNewRect({
          rectAttr: param.rectAttr,
          cellRect: colRectIds,
          index: 0,
          type: "new",
          isClone: false,
          parentIndex: param.insertIndex,
          gridLayoutId: gridLayoutId
        })
      }
      this.$nextTick(()=>{
        if(loadingType.indexOf(dragType)>-1){
          // 添加loading效果
          let rectDom = document.getElementsByClassName(`pageLayout_id_${layoutList.id}`)[0]
          // let isWaterFall = this.$store.state[this.request_prefix].page.isWaterFall  === 'waterFall' ? true : false
          // if( isWaterFall){
          //   rectDom = rectDom?.getElementsByClassName("layout-cell-container")[0]
          // }else{
            rectDom = rectDom?.getElementsByClassName("layout-cell-container")[0]
          // }
          rectDom?.getElementsByClassName("loading-wrap")[0].classList.add("loading-newRect")
          // rectDom?.setAttribute("isLoading",true)
          sessionStorage.setItem("isAddNewRect",true)
        }
      })
      this.$addHistory({
        type: "add",
        stateType: "addPageLayout",
        payload: {
          container_id: 0,
          pageLayoutId: layoutList.id,
          index: param.insertIndex
        }
      })
    },
    getParentNode(e, res = [], parentClass) {
      const parentNode = e.parentNode
      if (parentNode) {
        let elClasslist = parentNode.classList
        // if(elClasslist.length === 0){
        //   return res
        // }
        if ([].find.call(elClasslist, it => it === parentClass)) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNode(parentNode, res, parentClass)
        }
      } else {
        return res
      }
    },
    activateEv(id, index, shape) {
      // isShade 是判断是否是上层的遮罩
      // 控制缓存组件的appid同步
      this.clearSwiperElementActive()
      const myAttr = this.getRectAttribute.call(this, { container_id: id, rect_id: index })
      const myAppId = myAttr.appId
      if (myAppId) {
        const { moduleId, typeId } = this.getRectAttribute.call(this, { container_id: id, rect_id: index })
        this.initDataPageIds({ moduleId, typeId, appId: myAppId.appId })
      }

      if (JSON.parse(window.localStorage.getItem("oldActiveData")) !== "nothing") {
        const param = JSON.parse(window.localStorage.getItem("oldActiveData"))
        if (param && (param.container_id !== id || param.rect_id !== index) && param.uid) {
          param.option_name = "isActive"
          param.option_val = false
          this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
        }
      }
      if (!this.$store.state.states.alignHelperStatus && !localStorage.getItem("multipleComponent")) {
        this.$store.dispatch(this.request_prefix + "/setActive", {
          container_id: id,
          rect_id: index
        })
        //    }
      } else {
        this.$store.commit(this.request_prefix + "/ENABLE_ACTIVE", {
          container_id: id,
          rect_id: index
        })
        let newArr = JSON.parse(sessionStorage.getItem("tmpComponents")) || []
        if (localStorage.getItem("multipleComponent")) {
          newArr.push({
            container_id: id,
            rect_id: index
          })
        }else{
          newArr=[{
            container_id: id,
            rect_id: index
          }]
        }
        sessionStorage.setItem("tmpComponents", JSON.stringify(newArr))
      }      if (id !== null && index !== null && !shape.toLowerCase().includes("layoutComponent")) {
        // 放开了轮播图未激活时  在此激活的情况
        if (this.ids.container_id === id && this.ids.rect_id === index) {
          return
        }
        let param = {
          container_id: id,
          rect_id: index
        }
        this.$store.commit("states/changeActiveID", param)
        this.$store.commit("states/changeElementType", shape)
      }
      // 此时要保证通栏已经渲染完成，nextTick 不行
      setTimeout(()=>{
          // 增加上层布局的层级
          const curRect = $(`.container_id_${this.id}-rect_id_${index}`)
          $(".page-layout-wrapper[data-level='top-level']").removeAttr("data-level")
          $(".layout-col.zIndex999").removeClass("zIndex999")
          curRect.parents(".layout-col").addClass("zIndex999")
          $(curRect.parents(".page-layout-wrapper")[0]).attr("data-level", "top-level")
      },500)
    },
    openMyContainerSet(containerId) {
      if (this.isBigScreenPreview()) return
      //打开画布设置
      let activeID = {
        container_id: containerId
      }
      this.$store.commit("states/changeToolBarStatus", true)
      this.$store.commit("states/changeElementType", "container")
      this.ids.container_id !== containerId && this.$store.commit("states/changeActiveID", activeID)
    },
    // 展开父级工具栏
    displayAllHandles(e, layout, index) {
      this.setPageLayout(layout, index)
      $(e.target).parents(".new-btn-groups").find(".upper-handle-items .handle-btn-items").toggleClass("displayBlock")
      // 添加收起当前层级的工具栏
      this.isShowAllBtns = false
    },
    // 关闭抽屉回调
    closeDrawer(layout) {
      this.$eventBus.$emit("control-drawer", {
        openDrawer: false,
        sourceId: layout.options.source_id
      })
    },
    closePopper(layout) {
      this.$eventBus.$emit("control-popover", {
        openPopover: false,
        sourceId: layout.options.source_id
      })
    },
    // 打开资源库
    openImgLib(layout, idx) {
      // 模拟点击
      let bg = layout.options.bg
      let index = bg.findIndex(item => item.type === "img")
      let defaultImage = document.getElementsByClassName("toolbar")[0].getElementsByClassName("default-image") // 没有图片时生成默认值
      if (index === -1 && defaultImage.length > 0) {
        defaultImage[0].click()
      }
      let openLib = document.getElementsByClassName("toolbar")[0].getElementsByClassName("open_lib_btn") // 打开资源库按钮
      if (openLib.length > 0) {
        openLib[0].click()
        sessionStorage.setItem("openResourceLib", true)
      }
    },
    openBgColor(layout, index) {
      this.showColorSelector = !this.showColorSelector
    },
    setClick(layout, index) {
      this.setPageLayout(layout, index)
      this.showRightToolbar = true
    },
    subPageShadeClick() {
      this.handdleClearActive()
    },
    isHeaderRef(layout) {
      return (
        (layout.options.inDocument === "header" && layout.options.isRefHome) ||
        (layout.options.inDocument === "footer" && layout.options.isRefHome)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.myContainer.fixed {
  position: fixed;
  z-index: 9999 !important;
}
.myContainer .substage_shade {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}
::v-deep .page-layout-wrapper {
  position: relative;
  margin: 0 auto;
  &[data-level="top-level"] {
    z-index: 10001 !important;
    .layout-row__container > .vdr_shade:not(.show) {
      display: none;
    }
  }
  .container_btn {
    display: none;
    position: absolute;
    z-index: 999;
    left: 50%;
    bottom: -12px;
    transform: translateX(-50%);
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: var(--themeColor);
    color: #fff;
    cursor: pointer;
    padding: 0;
    .icon-portal-add_bold {
      display: inline-block;
      margin-top: -1px;
      font-size: 12px;
    }
    &.container_btn_top {
      top: -12px;
      bottom: auto;
    }
    &:hover {
      //background-color: #5685ff;
      background-color: var(--themeColorHover);
    }
  }
  &.hover-active {
    z-index: 10000 !important;
    &:not(.handleHide)> .page-layout-sets-wrap {
      display: block;
    }
    .container_btn {
      display: block;
    }
  }
  &.select-active {
    z-index: 10001 !important;
    > .page-layout-sets-wrap {
      display: block;
      .set-groups {
        display: inline-block !important;
      }
    }
    &::before {
      display: block;
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 2px dashed var(--themeColor);
    }
    .container_btn {
      display: block;
    }
  }

  .page-layout-sets-wrap {
    position: absolute;
    display: none;
    top: 30px;
    right: 30px;
    // 通栏设置按钮的布局应该在浮层上面
    z-index: 10001;
    width: 36px;
    text-align: right;
    overflow: visible;
    transition: width 0.5s;
    border-radius: 999px;
    box-sizing: border-box;
    &.hide {
      display: none;
    }
    &.overflow-hid {
      overflow: hidden;
    }
    &.unfold {
      width: 340px;
      .page-layout-sets {
        display: inline-flex;
      }
    }

    &.fold {
      width: 36px;
      .page-layout-sets {
        display: inline-block;
      }
    }

    .page-layout-sets {
      text-align: left;
      z-index: 9999;
      .set-groups {
        position: relative;
        display: inline-block;
      }
    }
    .page-layout-sets-more {
      padding: 0 8px;
    }
    .set-groups {
      &:not(:last-child) {
        border-right: 1px solid #42516d;
      }
    }
    .icon {
      position: relative;
      display: inline-block;
      text-align: center;
      cursor: pointer;
    }
    &.new {
      white-space: nowrap;
      text-align: left;
      border-radius: 0;
      top: auto;
      bottom: 100%;
      left: 0;
      width: auto;
      right: unset;
      &.left_220 {
        left: 220px;
      }
      &.is_top {
        top: 0;
      }
      &.is_bottom {
        top: 100%;
      }
      .page-layout-sets {
        padding: 0;
        overflow: visible;
      }
      .set-groups {
        &:not(:last-child) {
          border-right: 1px solid rgba(255, 255, 255, 0.2);
        }
      }
    }
    .mt2 {
      margin-top: 2px;
    }
    .line {
      display: inline-block;
      vertical-align: middle;
      height: 20px;
      width: 1px;
      background-color: var(--topOperationBorderColor);
      margin: 0 2px;
    }
  }
}

/**抽屉通栏样式*/
::v-deep .el-drawer__wrapper .page-layout-wrapper {
  height: 100%;
  .layout-row__container {
    height: 100%;
    .layout-col {
      height: 100%;
      .layout-columns {
        height: 100% !important;
      }
    }
  }
}

.myContainer {
  height: auto;
  min-height: 200px;
  position: relative;
  background-color: transparent;
  &.sub-head-page {
    min-height: auto;
  }
}

.myContainer.active {
  border: 1px solid #1d7ce2;
}

.saveModule {
  display: none;
  position: absolute;
  top: -42px;
  right: 0;
  width: 80px;
  text-align: center;
  font-size: 14px;
  color: var(--themeColor);
  line-height: 40px;
  border-radius: 0 4px 4px 0;
  height: 40px;
  background: #ffffff;
  border: 1px solid rgba(101, 101, 101, 0.2);
  border-left: none;
  cursor: pointer;
  z-index: 2;
}

.saveModule::before {
  position: absolute;
  content: "";
  top: 50%;
  left: 0;
  margin-top: -8px;
  height: 16px;
  width: 1px;
  background-color: #f2f2f2;
}

.save_module {
  width: 100%;
  padding: 10px 20px 0 20px;
  display: flex;
  flex-direction: row;
}
.grid-pageLayout-dragging {
  z-index: 10003 !important;
}
.grid-pageLayout-drag-over {
  cursor: grab;
}
.pageLayout-drag-over {
  cursor: grab;
}
.grid-pageLayout-drag-over-end:after {
  position: absolute;
  height: 1px;
  width: 100%;
  background-color: var(--themeColor);
  bottom: 0;
  content: "";
  z-index: 2;
}
.pageLayout-drag-over-end:after {
  position: absolute;
  height: 3px;
  width: 100%;
  background-color: var(--themeColor);
  bottom: 0;
  content: "";
  z-index: 2;
}
::v-deep .page-layout-wrapper:not(.anchor-layout) .layout-col.no-size-limit .layout-cell-container > .vdr {
  width: unset !important;
  height: unset !important;
}
</style>
<style lang="scss">
.myContainer > .handle-btn-groups {
  margin-top: 0;
  right: 0;
}

.myContainer.fixed > .handle-btn-groups {
  right: 0;
}

.handle-btn-groups {
  border-right: none;
  border-radius: 4px 0 0 4px;
}
.handle-btn-groups > div {
  display: flex;
}
.handle-btn-groups {
  position: absolute;
  right: 0;
  text-align: right;
  margin-top: -38px;
  border-radius: 4px;
  padding: 0 2px;
  min-width: 40px;
  height: 36px;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  font-size: 12px;
  z-index: 1001;

  + .saveModule {
    right: 2px;
    z-index: 1001;
  }

  .handle-icon-box {
    position: relative;

    &:hover {
      .icon-tips {
        display: block;
      }
    }

    .icon-tips {
      position: absolute;
      display: none;
      background: rgba(0, 13, 34, 0.9);
      border-radius: 4px;
      padding: 8px 12px;
      font-size: 14px;
      top: -46px;
      left: 50%;
      transform: translateX(-50%);
      color: rgba(255, 255, 255, 0.8);
      z-index: 2;
      line-height: 20px;
      box-sizing: border-box;
      word-break: keep-all;

      &:after {
        position: absolute;
        content: "";
        bottom: -10px;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-color: rgba(0, 13, 34, 0.9) transparent transparent;
        border-style: solid;
        z-index: 2;
      }
    }
  }

  .icon {
    display: inline-block;
    text-align: center;
    font-size: 20px;
    width: 28px;
    height: 28px;
    line-height: 28px;
    border-radius: 4px;
    color: #717989;

    &.active {
      color: #3d82f2;
      background: rgba(61, 130, 242, 0.1);
    }
  }

  i {
    margin-right: 2px;
    font-size: 16px;
  }

  div {
    cursor: pointer;
  }

  & > * {
    display: inline-block;
    vertical-align: middle;
  }
}

.container_bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  background-color: transparent;
}

.other_content .vdr.active {
  z-index: 100 !important;
}

.vdr_shade {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: transparent;
}
.vdr_shade:not(.no-drag) {
  cursor: default;
}
.boundingBox {
  position: absolute;
  background: rgba(61, 130, 242, 0.1);
  border: 1px solid rgba(61, 130, 242, 0.5);
  border-radius: 6px;
}

.distance-wrapper {
  position: absolute;
}

.closed-btn {
  display: flex;
  width: 32px;
  height: 32px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  z-index: 999;
  border-radius: 0px 0px 0px 8px;
  background: rgba(0, 0, 0, 0.4);
  justify-content: center;
  align-items: center;
  z-index: 10000;
  color: #ffffff;
  font-size: 18px;
}
.icon-portal-preview-close-one1::before {
  color: rgba(0, 0, 0, 0.8);
}
// 开启左侧导航框，通栏高度固定
.enable-left-nav .layout-row__container{
  height: 100vh;
}
</style>
